
import $ from 'jquery';
import _ from 'lodash';
import {View,Model} from 'backbone';
import util from 'util/Util';
import eventBus  from 'EventBus';
import BaseDashboardLeftPanelView from 'dashboard/BaseDashboardLeftPanelView.js';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import RestService from 'RestService';
import UndoService from 'UndoService';
import NotificationService from 'NotificationService.js';
import XJService from 'xml/XJService';
import FormAddService   from 'FormAddService.js';
import formFolderService   from 'FormFolderService.js';
import FormDetailsView from 'dashboard/forms/FormDetailsView.js'
import LibraryDetailsView from 'dashboard/forms/LibraryDetailsView.js';
import EditFormsDashboardView from 'dashboard/forms/EditFormsDashboardView.js';
import ViewFormsDashboardView from 'dashboard/forms/ViewFormsDashboardView.js';

import AppWorkspaceView from 'dashboard/forms/AppWorkspaceView.js';

import FormInstancesView from 'dashboard/forms/FormInstancesView.js';
import ViewableInstanceView from 'dashboard/forms/ViewableInstanceView.js'
import ViewableInstanceDetailView from 'dashboard/forms/ViewableInstanceDetailView.js'
import EditFormsViewableInstanceDetailView from 'dashboard/forms/EditFormsViewableInstanceDetailView.js'
import FormDetailsModel   from 'FormDetailsModel';
import FormMainView from 'dashboard/forms/FormMainView.js';
import ViewableInstanceDetailModel   from 'ViewableInstanceDetailModel.js';
import ViewableInstanceModel   from 'ViewableInstanceModel.js';
import LibraryDetailsModel   from 'LibraryDetailsModel.js';
import constants        from 'Constants.js';
import textConstants        from 'TextConstants.js';
import singleItemTemplate    from 'dashboard/single-item.ejs';
import listService          from 'ListService.js';
import ImportModal from 'common-views/ImportModalView.js';
import userService      from 'UserService.js';
import restMessages from 'RestMessages';
import NewArchiveModel from 'NewArchiveModel';
import NewArchiveDetailsView from 'dashboard/settings/NewArchiveDetailsView';
import DeleteModal              from 'dashboard/forms/modal/FormDeleteModal.js';
import commonService from 'CommonService.js';
import appService from "AppService.js";

const ICON_FOLDER = constants.DB_ICON_FOLDER;
const ICON_FOLDER_ACCOUNT = constants.DB_ICON_FOLDER_ACCOUNT;
const ICON_EMPTY = constants.DB_ICON_EMPTY;

class FormLeftPanelView extends BaseDashboardLeftPanelView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.originalResponse;
        // Most Events Should be at Base
        //this.events = {};
        this.bounceDelay = 500;
        this.openNewForm = false;

        // structure to load List
        var sections = {
            sections: [
                {
                    sectionName: 'Edit Apps',
                    sectionType: 'sectionEditForms',
                    groupType: 'section',
                    id: constants.FORMS_VIEW_GROUP_TYPE,
                    nodeType: 'editForms',
                    groups: [
                        {
                            groupName: 'Private',
                            nodeType: 'PrivateForms',
                            id: constants.FORMS_PRIVATE_GROUP_TYPE,
                            nodes: []
                        },
                        {
                            groupName: 'Shared',
                            nodeType: 'SharedForms',
                            id: constants.FORMS_SHARED_GROUP_TYPE,
                            nodes: []
                        }
                    ]
                },
                {
                    sectionName: 'View Apps',
                    sectionType: 'sectionViewForms',
                    groupType: 'viewForms',
                    id: constants.FORMS_VIEW_GROUP_TYPE,
                    nodeType: 'viewForms',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'Library',
                    sectionType: 'sectionLibrary',
                    nodeType: 'library',
                    groups: [],
                    nodes: [],
                    id: constants.FORMS_LIBRARY_GROUP_TYPE
                }
            ]
        };

        this.listenTo(eventBus, constants.SWITCH_DETAIL_FORM, this._onDetailFormSwitch);
        this.listenTo(eventBus, 'shareForm', this.shareForm);
        this.listenTo(eventBus, 'unShareForm', this.unShareForm);
        this.listenTo(eventBus, 'deletingForm', this._onDeletingForm);
        this.listenTo(eventBus, 'deletingDraftInstance', this._onDeletingDraftInstances);
        this.listenTo(eventBus, 'newInstance', this.reloadFormDetails);
        this.listenTo(eventBus, 'getFormInstance', this.getFormInstances);
        this.listenTo(eventBus, 'getAllFormInstance', this.getAllFormInstances);
        this.listenTo(eventBus, 'loadViewByInstance', this.loadViewByInstance);
        this.listenTo(eventBus, 'deployForm', this.reloadFormDetails);
        this.listenTo(eventBus, 'undoFormFolder', this.undoFormFolder);
        this.listenTo(eventBus, constants.EV_UPDATE_FORM_DETAILS, this.reloadFormDetails);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_FORM_DETAILS, this.openUndeletedFormDetails);
        this.listenTo(eventBus, constants.IMPORT_LIBRARY_SUCCESS, this._reloadPrivateForms);
        this.listenTo(eventBus, 'viewFormDetails', this.renderEditFormsViewableInstanceDetailView);
        this.listenTo(eventBus, 'loadViewForm', this.loadViewableFormInstanceDetails);
        this.listenTo(eventBus, constants.DASHBOARD_LOADED, this._createAutocomplete);

        this.listenTo(eventBus, constants.EV_NEW_PRIVATE_FORM, this._addAndOpenStarterForm);
        this.listenTo(eventBus, constants.EV_REFRESH_EDIT_FORMS_DASHBOARD, this.renderEditFormsDashboard);
        this.listenTo(eventBus, constants.EV_REFRESH_PRIVATE_NODES, this.loadPrivateOrSharedForms);
        this.listenTo(eventBus, constants.EV_REFRESH_FOLDER, this.renderFolderNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_FORM, this.renderFormNodeAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_VIEW_FORM_AND_DETAIL, this.renderViewFormNodeAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_FORM_INSTANCES, this.renderFormInstancesNodeAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_VIEW_FORMS, this.renderViewFormsNodeAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_LIBRARY_FORMS, this.renderLibraryForms);
        this.listenTo(eventBus, constants.EV_REFRESH_LIBRARY_FOLDER, this.renderLibraryForms);
        this.listenTo(eventBus, constants.EV_REFRESH_FORM_INSTANCE_DETAILS, this.renderEditFormsViewableInstanceDetailView);
        this.listenTo(eventBus, constants.EV_REFRESH_LIBRARY_DETAILS, this.renderLibraryDetails);
        this.listenTo(eventBus, constants.EV_REFRESH_FORMS_MAIN_VIEW_DETAILS, this.refreshFormsMainView);

        this.listenTo(eventBus, "displayDefaultEditFormsDetailView", this.displayDefaultEditFormsDetailView);
        this.listenTo(eventBus, "undeletingFormFolder", this.undeletedFormFolder);

        this.model.set('formSections', sections, {silent: true});
        this.model.set('currentActiveSection', 'formSections', {silent: true});
//        this.listenTo(this.model, 'change', this.render);

        this.reloadFormDetailsDebounced = _.debounce((formId, groupType, itemId)=>{
            if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
                util.disableReloadLink();
                RestService.getFormDetails(formId).then((formDetailsResult) => {
                    util.enableReloadLink();
                    this.renderAndBindFormDetailView(formDetailsResult, formId, groupType, itemId);
                    if (this.openNewForm) {
                        $('#designForm').trigger("click");               
                    }
                   
                }).catch((error) => {
                    util.enableReloadLink();
                    console.log(error);
                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                });
            }
        }, this.bounceDelay, {leading:true, trailing:false});

        return this;
    }

    _addAndOpenStarterForm() {
        // PF-4507: brokenby: wantItOpened should be false so the newly ctreated form it's auto-selected on the tree
        const wantItOpened = false;
        this.openNewForm = true;
        this.processAddFormOnPrivate(wantItOpened);
    }

    // PF-3607 Autocomplete Widget that search for form given a respective term.
    _createAutocomplete(ev) {
        const self = this;
        let cache={};
            $("#formReportSearch").autocomplete({
                delay:1000,
                focus: function( event, ui ) {
                    $( "#formReportSearch" ).val( ui.item['@name']  );
                    return false;
                  },
                source: function (request, response) {
                    let term = request.term;
                    if(term in cache){
                        console.log(cache[term]);
                        response(cache[term]);
                        return;
                    }
                    RestService.searchFormByName(term).then(results => {
                        console.log('The Results',results);
                        if(results.RESULT.RESPONSE.Group){
                            const items=results.RESULT.RESPONSE.Group.Item instanceof Array ?
                                    results.RESULT.RESPONSE.Group.Item :
                                    [results.RESULT.RESPONSE.Group.Item];
                            cache[term]=items;
                            response(items);
                        } else{
                             response([]);
                        }
                    }, err => {
                       NotificationService.error('Error while searching apps:',err);
                       console.log(`Error while searching apps:`, err);
                     })
                },
                select: function (event, ui) {
                   if(util.isTrue(userService.checkPermissions('App'))){
                        self.reloadFormDetails(ui.item["@id"]);
                   }
                   else{

                    commonService.getBasicModel(ui.item["@id"], ui.item["@name"], appService.createNewSimpleModel).then((appModel)=>{
                        commonService.openSimpleView(appModel, "app");
                    });
                       
                   }
                }
        }).autocomplete( "instance" )._renderItem = function( ul, item ) {
            return $( "<li>" )
              .append( "<div formId='"+item["@id"]+"' groupId='"+item["@GroupId"]+"'>" + item['@name']  + "</div>" )
              .appendTo( ul );
          };
    }

    _reloadPrivateForms(result) {
        let isAddedOnRoot = false;
        this.expandUpdatedListOfPrivateNodes(isAddedOnRoot,result);
        NotificationService.success( result.msg );
    }

    _onDetailFormSwitch(event) {
        if (event.detailPage === 'ViewableInstanceDetailView') {
            this.renderViewableInstanceDetailView(event.payload.instanceId);
            // Finding the element so we can select it.
            let element = $(`a[data-itemid="${event.payload.instanceId}"]`);
            if (element) {
                // Removing previous selections.
                this.removeItemGroupSelection();

                // Selecting element.
                this.addItemGroupSelection(element);
            }
        }
    }

    // Method that checks for a node added on the private root section.
    wasAddedOnPrivateRoot(selector){
        return $(selector)
            .parent()
            .parent()
            .parent()
            .siblings()
            .text()
            .trim()
            .indexOf('Private') > 0;
    }

    // Method that processes if a folder should be expanded to retrieve items or just only add a node if it is already expanded
    // PRIVATE SECTION
    expandUpdatedListOfPrivateNodes(isAddedOnRoot, newFormResponse, groupType, groupId, nodeTarget, element,wantItOpened = false, forceOpen = false){

        let groupTypeToBrowse=groupType;
        let groupIdToBrowse=groupId;
        let nodeTargetToBrowse=nodeTarget;
        if(nodeTarget === undefined || nodeTarget === constants.EDIT_FORMS_CONTAINER){
            $(constants.EDIT_FORMS_SECTION_CONTAINER).collapse('show');
            groupTypeToBrowse=constants.FORMS_PRIVATE_GROUP_TYPE;
            groupIdToBrowse=constants.DEFAULT_GROUP_ID;
            nodeTargetToBrowse=constants.EDIT_FORMS_CONTAINER
        }

        if(element){
            $(nodeTarget + ' ul li').last().after(element);
        }
        else {
            if (((!$(nodeTargetToBrowse).is(':visible') && !isAddedOnRoot))
                || (nodeTargetToBrowse === constants.EDIT_FORMS_CONTAINER && !$(nodeTargetToBrowse).is(':visible'))) {
                this.addNodeAndExpand(groupTypeToBrowse, groupIdToBrowse, nodeTargetToBrowse, newFormResponse, 'Edit Forms');
            }
            else {
                this.addNode(isAddedOnRoot, nodeTargetToBrowse, groupTypeToBrowse, newFormResponse);
            }
        }

        if (newFormResponse.msg){
            NotificationService.success( newFormResponse.msg );
        }
    }

    // Method that processes if a folder should be expanded to retrieve items or just only add a node if it is already expanded
    // SHARED SECTION
    expandUpdatedListOfSharedNodes(isAddedOnRoot,newFormResponse,groupType,groupId,nodeTarget){
        let groupTypeToBrowse=groupType;
        let groupIdToBrowse=groupId;
        let nodeTargetToBrowse=nodeTarget;
        if(nodeTarget ===constants.SHARED_FORMS_CONTAINER || (groupType === constants.FORMS_SHARED_GROUP_TYPE && isAddedOnRoot)) {
            $(constants.SHARED_FORMS_CONTAINER).collapse('show');
            let element = $(constants.SHARED_FORMS_CONTAINER).find("i")[0];
            console.log("Element Shared", $(element));
            nodeTargetToBrowse=$(element).attr('data-target');
            groupIdToBrowse=$(element).attr('data-itemid');
        }


        if ($(nodeTargetToBrowse).is(':visible') || !$(nodeTargetToBrowse).is(':hidden'))
            //|| (nodeTargetToBrowse === constants.EDIT_FORMS_CONTAINER && !$(nodeTargetToBrowse).is(':visible'))){
        {
            this.addNode(isAddedOnRoot,nodeTargetToBrowse,groupTypeToBrowse,newFormResponse);
        } else {
            this.addNodeAndExpand(groupTypeToBrowse,groupIdToBrowse,nodeTargetToBrowse,newFormResponse,'Edit Forms');
        }

        if (newFormResponse.msg){
            NotificationService.success( newFormResponse.msg );
        }
    }

    // Method that retrieves the nodes from the API and attaches them on the given node.
     addNodeAndExpand(groupType, groupId, nodeTarget, newFormResponse, section){
        let groupIdToSend = groupId || constants.DEFAULT_GROUP_ID;
         RestService.getFormsByGroupType(groupType, groupIdToSend).then(data => {
             this.selectedNodeOnTree = this.renderFormBrowseNodes(groupType, groupId, nodeTarget, data, section);

             $(nodeTarget).collapse('show');

             const
                 formId = newFormResponse.formId,
                 selArg = `${groupType}-${formId}`,
                 sel = `i[data-itemid*='${selArg}']`,
                 $item = $(sel);

             $item.parent('li').addClass('bg-success');


             this.reloadFormDetails(formId, newFormResponse.groupType, newFormResponse.itemId);

             let self = this;

             // Scroll item into view in tree that exceeds view
             setTimeout(function () {
                 const offset = $item.offset();

                 if (offset) {
                     Element.prototype.documentOffsetTop = function () {
                         return this.offsetTop + ( this.offsetParent ? this.offsetParent.documentOffsetTop() : 0 );
                     };

                     const documentOffsetTop = offset.top;

                     const top = documentOffsetTop - window.innerHeight / 2;
                     $('.dashboard-left-rail-scroll').scrollTop(top);
                 }

                 setTimeout(() => {  self.setCreateNewFormLink(); }, 1500);
             }, 0);
         }, error => {
             const msg = error && error.CODE ? restMessages.codeToMessage( error.CODE ) : 'Unknown error';
             NotificationService.error(msg);
             this.setCreateNewFormLink();

         }).catch((error) => {
             console.log(error);

             const msg = error || 'Unknown Error';
             NotificationService.error(msg);
             this.setCreateNewFormLink();
         });
     }

    // Method that just appends a node on a given element that is already expanded.
     addNode(isAddedOnRoot,nodeTarget,groupType,newFormResponse){
         let targetToAddItem;
         if(groupType ===constants.FORMS_SHARED_GROUP_TYPE) {
             targetToAddItem = $(nodeTarget + ' UL');
         }
         else{
             targetToAddItem = $(nodeTarget + ' UL');
             if (!targetToAddItem.length) {
                let target = $(nodeTarget);

                if (target.attr('data-nodetype') === 'group') {
                    targetToAddItem = $(target.attr('data-target') + ' ul');
                }
             }
         }

         const newNode = { node: {
             id:groupType + '_' + newFormResponse.formId,
             groupType: groupType,
             icon: ICON_EMPTY,
             nodeType: 'attn',
             nodeName: newFormResponse.name,
             toggleIcon: '',
             parentId: null,
             selected: true }
         };

         // clear other selections
         $('li[role="button"]').removeClass('bg-success');

         if( $(targetToAddItem.children()[0]).text().trim()=== 'no items'){
             $(targetToAddItem.children()[0]).remove();
         }
         $(targetToAddItem[0]).append( singleItemTemplate( newNode ) );
         this.reloadFormDetails(newFormResponse.formId, newFormResponse.groupType, newFormResponse.itemId);
        let self = this;

        setTimeout(() => {
                Element.prototype.documentOffsetTop = function () {
                    return this.offsetTop + ( this.offsetParent ? this.offsetParent.documentOffsetTop() : 0 );
                };

                var item = document.querySelector(`i[data-itemid*="${groupType+'_'+newFormResponse.formId}"]`);
                if (item) {
                    var top = item.documentOffsetTop() - ( window.innerHeight / 2 );
                    $('.dashboard-left-rail-scroll').scrollTop( top );
                }

                //super.makeDraggables();

                setTimeout(() => { self.setCreateNewFormLink(); }, 1500);
            }, 0);
     }

     // Method that adds a form inside the private category and performs validations.
    processAddFormOnPrivate( wantItOpened = false, forceDesignMode = false ){
        let groupIdToAdd=this.selectedNodeOnTree || constants.DEFAULT_GROUP_ID;
        groupIdToAdd = groupIdToAdd === constants.FORMS_PRIVATE_GROUP_TYPE ? constants.DEFAULT_GROUP_ID : groupIdToAdd;
        let isAddedOnRoot=false;

        if (typeof this.selectedNodeParentId === 'undefined' || 
                   this.selectedNodeParentId === 0 || 
                   this.selectedNodeParentId === -1 || 
                   this.selectedNodeParentId === constants.DEFAULT_GROUP_ID ) {
            groupIdToAdd=constants.DEFAULT_GROUP_ID;
            isAddedOnRoot=true;
            this.selectedNodeTarget = constants.EDIT_FORMS_CONTAINER;
            this.selectedGroupType = constants.FORMS_PRIVATE_GROUP_TYPE;
        }
        else {
            groupIdToAdd = this.selectedNodeParentId;
            this.selectedNodeTarget = `a[data-itemid="${groupIdToAdd}"]`;
        }

        this.setCreateNewFormLink(true, 'li-disabled');

        // API Call to Form/Add
        FormAddService.newForm({groupId:groupIdToAdd},this.selectedGroupType,this.selectedNodeOnTree,this.selectedNodeTarget).then( (result) =>{

            // Process Closed and Form Instances
            // Render Either View or Edit Form
            this.expandUpdatedListOfPrivateNodes(isAddedOnRoot, result, this.selectedGroupType,
                this.selectedNodeOnTree, this.selectedNodeTarget, wantItOpened, forceDesignMode);


        }, ( errMsg ) =>{
            NotificationService.error( errMsg );
            this.setCreateNewFormLink();
        });
    }

    // Method that adds a form inside the shared category and performs validations.
    processAddFormOnShared(){
        let isAddedOnRoot = false;
        let groupIdToAdd = this.selectedNodeParentId;

        this.setCreateNewFormLink(true, 'li-disabled');

        if (this.selectedNodeParentId === 0 || this.selectedNodeParentId === -1 || this.selectedNodeParentId === constants.DEFAULT_GROUP_ID) {
                let element = $(constants.SHARED_FORMS_CONTAINER).find("i")[0];
                console.log("Element Shared", element);
                this.selectedNodeTarget=$(element).attr('data-target');
                this.selectedNodeOnTree = $(element).attr('data-itemid').indexOf('_') > 0
                    ? $(element).attr('data-itemid').substring(2)
                    : $(element).attr('data-itemid');
                isAddedOnRoot = true;
                if ($(this.selectedNodeTarget).is(':visible')) {
                    $(this.selectedNodeTarget).collapse('hide')
                }

                groupIdToAdd = this.selectedNodeOnTree;
        }

        FormAddService.newForm({groupId: groupIdToAdd, isPrivate:false},this.selectedGroupType,this.selectedNodeOnTree,this.selectedNodeTarget).then( (result) =>{
            // Insert Node into Tree
            // Process Closed and Form Instances
            // Render Either View or Edit Form
            console.log("Is Expanded",$(this.selectedNodeTarget).is(':visible'));
            this.expandUpdatedListOfSharedNodes(isAddedOnRoot,result,this.selectedGroupType,this.selectedNodeOnTree,this.selectedNodeTarget);
        }, ( errMsg ) =>{
            NotificationService.error( errMsg );
        });
    }

    setCreateNewFormLink(disabled = false, className = '') {
        let element = document.getElementById("createNew");
        if(element){
            element.className = className;
            if(element.disabled){
                element.disabled = disabled;
            }
        }
    }

    import() {
        let model = new Model({width: 475, height: 'auto'});

        var importModal = new ImportModal({ model: model, el:content });
        importModal.selectedImport = 'form';
        importModal.render();
    }

    createNew(ev) {
        switch(this.selectedGroupType) {
            case "1":
                this.processAddFormOnPrivate();
                break;
            case "2":
                this.processAddFormOnShared();
                break;
            default:
                this.processAddFormOnPrivate();
            break;
        }
    }

    createFolder(ev){
         switch(this.selectedGroupType){
            case constants.FORMS_PRIVATE_GROUP_TYPE:
            case constants.FORMS_SHARED_GROUP_TYPE:
                this.processAddFormFolder();
                break;
             case 'viewForms':
             case constants.ACCOUNT_FOLDER_GROUP_TYPE :
             case constants.PERSONAL_FOLDER_GROUP_TYPE :
             case constants.FORMS_VIEW_GROUP_TYPE :
                 this.processAddPrivateOrAccountFolder(ev);
                 break;
        }
    }

    processAddPrivateOrAccountFolder(ev){
        let folderTypeChosen=$(ev.currentTarget).data('group-type');
        console.log("Folder Type Chosen",folderTypeChosen);
        let folderParent=$(".bg-success > a").data('parentid');
        let isAddedOnRoot;
        if(util.isEmpty(folderParent)){
            folderParent = constants.DEFAULT_GROUP_ID;
            isAddedOnRoot = true;
        }
        else{
            isAddedOnRoot = false
        }

        formFolderService.newFormFolder({ name: constants.DEFAULT_FORM_FOLDER_NAME, groupTypeId: folderTypeChosen, groupParentId: folderParent, isAddedOnRoot: isAddedOnRoot}).then((result) => {
            let iconFolder = ICON_FOLDER;
            if(String(folderTypeChosen) === constants.ACCOUNT_FOLDER_GROUP_TYPE ){
                iconFolder = ICON_FOLDER_ACCOUNT;
            }

            NotificationService.success(result.msg);
            let targetToAddItem = isAddedOnRoot ? $(constants.VIEW_FORMS_CONTAINER + ' UL') : $(`#well${folderParent} UL`);

            const newNode = {
                node: {
                    nodeName: result.name,
                    icon: iconFolder,
                    nodes: [],
                    id: result.formFolderId,
                    groupType: folderTypeChosen,
                    nodeType: 'group',
                    hasChildren: false,
                    parentId:  result.formFolderId,
                    toggleIcon: 'pf-carot-left',
                    selected:true
                }
            };

            // clear other selections
            $('li[role="button"]').removeClass('bg-success');


            if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
                $(targetToAddItem.children()[0]).remove();
            }

            // PF-3982: Fix for new folders on root level
            newNode.node.parentId = newNode.node.parentId || newNode.node.id;

            $(targetToAddItem[0]).append(singleItemTemplate(newNode));

            // PF-4679 Adding Right Click and Drag Drop to this area?
            // setTimeout(()=>{
            //     super.makeDroppables( this.expandUpdatedListOfPrivateNodes );
            //     super.attachRightClickMenu();
            // },0);
        }, (errMsg) => {
            NotificationService.error(errMsg);
        });
    }

    processAddFormFolder() {
        let isAddedOnRoot = constants.DEFAULT_GROUP_ID === this.selectedGroupParentId;

        // API Call to Form/Add
        let _groupParentId = this.selectedNodeParentId;
        if (typeof _groupParentId === 'undefined'){
            _groupParentId = this.selectedGroupParentId;
        }

        formFolderService.newFormFolder({ name: constants.DEFAULT_FORM_FOLDER_NAME, groupTypeId: this.selectedGroupType, groupParentId: _groupParentId, isAddedOnRoot: isAddedOnRoot}).then((result) => {
            NotificationService.success(result.msg);

            // Process Closed and Form Instances
            // Render Either View or Edit Form
            /*console.log("Is expanded", $(this.selectedNodeTarget).is(':visible'));*/
            //this.expandUpdatedListOfPrivateNodes(isAddedOnRoot, result, this.selectedGroupType, this.selectedNodeOnTree, this.selectedNodeTarget);
            let targetToAddItem;
            if (this.selectedGroupType === constants.FORMS_SHARED_GROUP_TYPE) {
                targetToAddItem = isAddedOnRoot ? $(constants.SHARED_FORMS_CONTAINER + ' UL') : $(`#well${_groupParentId} UL`);
            } else {
                targetToAddItem = isAddedOnRoot ? $(constants.EDIT_FORMS_SECTION_CONTAINER + ' UL') : $(`#well${_groupParentId} UL`);
            }

            const newNode = {
                node: {
                    nodeName: result.name,
                    icon: ICON_FOLDER,
                    nodes: [],
                    id: result.formFolderId,
                    groupType: this.selectedGroupType,
                    nodeType: 'group',
                    hasChildren: false,
                    parentId:  result.formFolderId,
                    toggleIcon: 'pf-carot-left'
                }
            };

            // clear other selections
            $('li[role="button"]').removeClass('bg-success');


            if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
                $(targetToAddItem.children()[0]).remove();
            }

            // PF-3982: Fix for new folders on root level
            newNode.node.parentId = newNode.node.parentId || newNode.node.id;

            $(targetToAddItem[0]).append(singleItemTemplate(newNode));
            setTimeout(()=>{
                super.makeDroppables( this.expandUpdatedListOfPrivateNodes );
                super.attachRightClickMenu();
            },0);
        }, (errMsg) => {
            NotificationService.error(errMsg);
        });
    }

    undoFormFolder(name,groupId,groupTypeId,groupParentId,message) {

        let targetToAddItem;
        if (groupTypeId === constants.FORMS_SHARED_GROUP_TYPE) {
            targetToAddItem = groupParentId ? $(`#well${groupParentId} UL`) : $(constants.SHARED_FORMS_CONTAINER + ' UL');
        } else {
            targetToAddItem = groupParentId ? $(`#well${groupParentId} UL`) : $(constants.EDIT_FORMS_SECTION_CONTAINER + ' UL');
        }

        const newNode = {
            node: {
                nodeName: name,
                icon: ICON_FOLDER,
                nodes: [],
                id: groupId,
                groupType: this.selectedGroupType,
                nodeType: 'group',
                hasChildren: false,
                parentId: groupParentId,
                toggleIcon: 'pf-carot-left',
                selected: true
            }
        };

        // clear other selections
        $('li[role="button"]').removeClass('bg-success');


        if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
            $(targetToAddItem.children()[0]).remove();
        }

        // PF-3982: Fix for new folders on root level
        newNode.node.parentId = newNode.node.parentId || newNode.node.id;

        $(targetToAddItem[0]).append(singleItemTemplate(newNode));
        setTimeout(() => {
            super.makeDroppables(this.expandUpdatedListOfPrivateNodes);
            super.attachRightClickMenu();
        }, 0);

        if (message) {
            NotificationService.success(message);
        }
    }

    undeletedFormFolder(selectedGroupType, isAddedOnRoot, groupParentId, result){
        let targetToAddItem;
            if (selectedGroupType === constants.FORMS_SHARED_GROUP_TYPE) {
                targetToAddItem = isAddedOnRoot ? $(constants.SHARED_FORMS_CONTAINER + ' UL') : $(`#well${groupParentId} UL`);
            } else {
                targetToAddItem = isAddedOnRoot ? $(constants.EDIT_FORMS_SECTION_CONTAINER + ' UL') : $(`#well${groupParentId} UL`);
            }

            const newNode = {
                node: {
                    nodeName: result.name,
                    icon: ICON_FOLDER,
                    nodes: [],
                    id: result.formFolderId,
                    groupType: selectedGroupType,
                    nodeType: 'group',
                    hasChildren: false,
                    parentId: result.formFolderId,
                    toggleIcon: 'pf-carot-left'
                }
            };

            // clear other selections
            $('li[role="button"]').removeClass('bg-success');


            if ($(targetToAddItem.children()[0]).text().trim() === 'no items') {
                $(targetToAddItem.children()[0]).remove();
            }

            // PF-3982: Fix for new folders on root level
            newNode.node.parentId = newNode.node.parentId || newNode.node.id;

            $(targetToAddItem[0]).append(singleItemTemplate(newNode));
            setTimeout(()=>{
                super.makeDroppables( this.expandUpdatedListOfPrivateNodes );
                super.attachRightClickMenu();
            },0);
    }

    renderFormBrowseNodes(groupType,id,target,formItems,sectionName){
        let forms = formItems.RESULT.RESPONSE.Group;

        var nodes = [];
        if (forms) {
            nodes = this.loadNodesFromResponse(forms, groupType, id);
        } else {
            nodes = [{
                nodeName: 'no items',
                url: '#',
                icon: ICON_EMPTY,
                id: 0,
                groupType: groupType,
                nodeType: '',
                parentId: null,
                hasChildren: false
            }]
        }

        var group = this.replaceGroupItemsInModel('formSections', sectionName, groupType, nodes);
        if($.isEmptyObject(group)){
            group = {
                nodes:nodes
            }
        }
        this.addItemsToGroup(group, target);

        return group.id;
    }

    checkForEnablingViewFormsMenu(eventTarget){
        let targetToWork = eventTarget;
        if(eventTarget.is('h4')){
            targetToWork = eventTarget.find('a');
        }
        else if(eventTarget.is('i')){
            targetToWork = eventTarget.parent();
        }
        let currentSection = targetToWork.data('nodetype');
        let groupType = String(targetToWork.data('grouptype'));
        if(currentSection === 'viewForms'){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
        else if(currentSection === 'viewForms' && targetToWork.text().includes('View Apps')){
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
        else{
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").addClass('hide');
        }
        if(groupType === constants.ACCOUNT_FOLDER_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().addClass('li-disabled');
        }
        else if(groupType === constants.PERSONAL_FOLDER_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().addClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }
    }

    handleExpand(ev) {
        try {
            ev.preventDefault();
            this.attachRightClickMenu();
            this.contextMenus && typeof this.contextMenus.close === 'function' && this.contextMenus.close();
        } catch (e) {
            console.log("error", e);
        }
        let eventTarget = $(ev.target);
        this.checkForEnablingViewFormsMenu(eventTarget);
        this.retrieveFormNodes(ev);
    }

    retrieveFormNodes(ev, removeSelection = true) {

        ev.stopPropagation();


        listService.dashboardFormsItems.setDefaultValue();

        let eventTarget = $(ev.target);
        this.checkForEnablingViewFormsMenu(eventTarget);


        if (removeSelection && !eventTarget.is('i')) {
            this.removeItemGroupSelection();
        }
        let hasChildren = eventTarget.attr('data-haschildren');
        let isFormWithNoChildren = (eventTarget.attr('data-nodetype') === 'attn' && hasChildren === 'false') || eventTarget.attr('title') === 'no items';

        if (isFormWithNoChildren) {
            return;
        }

        let itemSelected = $(ev.currentTarget).closest('div').find('.bg-success');

        if (itemSelected.length > 0){
            listService.dashboardFormsItems
                .setDefaultValue();
        }

        var itemId = ev.currentTarget.attributes['data-itemid'].value;
        var groupType = ev.currentTarget.attributes['data-groupType'].value;
        var nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        if (nodeType === 'group') {
            let folderSelected = {
                formId: itemId,
                formName: eventTarget.text(),
                groupId: '',
                groupType: groupType,
                nodeType: nodeType
            };

            listService.dashboardFormsItems
                .setDefaultValue()
                .setPropValue('formFolderSelected', folderSelected);
        }

        let dataTarget;
        let className;
        let siblings;

        if ((eventTarget .parents('#well_2').length || eventTarget.parents('#well_3').length || eventTarget.parents('#well_4').length) && nodeType === 'group' && eventTarget.is('a')) {
            let closestIcon = eventTarget.siblings('i');
            className = closestIcon.attr('class');
        }
        else
        {
            className = ev.currentTarget.className;
        }

        if (ev.currentTarget.attributes['data-target']) {
            dataTarget =  ev.currentTarget.attributes['data-target'].value;
        }

        // nodeType should drive what type of action needs to happen (i.e. API Call and View rendered as a result)
        // don't process on the collapse
        if (new RegExp('collapsed').test(className)) {

            const _none = () => { };

            const _editForms = () => {
                this.handleSection(ev);
            };

            const _group = () => {

                switch (groupType) {
                    case constants.FORMS_LIBRARY_GROUP_TYPE:
                        RestService.getLibraryForms(groupType, itemId).then((data) => {
                            let forms = data.RESULT.RESPONSE.Group;
                            var nodes = [];

                            if (forms) {
                                nodes = this.loadNodesFromResponse(forms, groupType);
                            } else {
                                nodes = [{
                                    nodeName: 'no items',
                                    url: '#',
                                    icon: ICON_EMPTY,
                                    id: 0,
                                    groupType: groupType,
                                    nodeType: '',
                                    parentId: null,
                                    hasChildren: false
                                }]
                            }
                            let group = {
                                nodes: nodes
                            };

                            this.addItemsToGroup(group, dataTarget);
                            this.selectedNodeOnTree = group.id;
                            this.selectedNodeTarget = dataTarget;
                            this.selectedGroupType = groupType;
                            this.selectedNodeType = nodeType;
                        }).catch((error) => {
                            console.log(error);

                            var msg = error || 'Unknown Error';
                            NotificationService.error(msg);
                        });

                        break;
                    default:
                        this.renderFolderNodes(itemId,groupType,nodeType,dataTarget);
                }

            };

            const _browseFormInstances = () => {
                var dataTarget = ev.currentTarget.attributes['data-target'].value;
                // PF-3982: Avoid making calls to the backend over and over
                if ($(dataTarget).find('ul li').length) {
                    $(ev.target).toggleClass('pf-carot-left pf-carot-down');
                    return;
                }

                var isClosed = ( new RegExp('CLOSED').test(itemId) ) ? true : false;
                var isArchived = false;
                let formId = itemId.replace('OPEN_INST', '').replace('CLOSED_INST', '');

                this.renderFormInstancesNodes(itemId, formId, isClosed, isArchived, nodeType, groupType, dataTarget);
            };

            const _viewForms = () => {
                const mapSectionType = {'1': 'Edit Apps', 'A': 'View Apps'};
                var groupTypeId = itemId;
                var sectionName = mapSectionType[itemId];

                if (util.isTrue(userService.checkPermissions('folders'))){
                    $('#createFolder').parent('li').removeClass('li-disabled');
                }else{
                    $('#createFolder').parent('li').addClass('li-disabled');
                }

                RestService.getPublishedForms().then((data) => {
                    let forms = data.RESULT.RESPONSE.Group;
                    var nodes = [];
                    if (forms) {
                        nodes = this.loadNodesFromResponse(forms, groupTypeId);
                    } else {
                        nodes = [{
                            nodeName: 'no items',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: groupType,
                            nodeType: '',
                            parentId: null,
                            hasChildren: false
                        }]
                    }

                    var group = {};
                    if (sectionName === 'View Apps') {
                        group = {
                            nodes: nodes
                        };

                    }
                    //var group = this.replaceGroupItemsInModel('formSections', sectionName, itemId, nodes);
                    this.addItemsToSection(group, dataTarget);
                    this.selectedNodeOnTree = group.id;
                    this.selectedNodeTarget = dataTarget;
                    this.selectedGroupType = groupType;
                    this.selectedNodeType=nodeType;
                }).then(() => {
                    this.handleSection(ev);
                }).catch((error) => {
                    console.log(error);

                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                });
            };

            const _browseViewableFormInstances = () => {
                //var dataTarget = ev.currentTarget.attributes['data-target'].value;
                //$('[data-target="'+ dataTarget + '"]').toggleClass('pf-carot-left pf-carot-down');
                // ItemId in this case will be {GROUPTYPE}-{FORMID}
                var formId = itemId.substring(2);
                var emptyNode = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    parentId: null,
                    hasChildren: false
                }];

                RestService.getViewableInstances(formId).then((data) => {
                    let instances = data.RESULT.RESPONSE.InstanceList;

                    if (instances) {
                        var nodes = [];
                        if (instances.Instance) {
                            nodes = this.loadInstancesFromResponse(instances.Instance, groupType);
                        } else {
                            nodes = emptyNode;
                        }
                    } else {
                        nodes = emptyNode;
                    }

                    // need base method to replace Section Items in model (Edit Forms/ View Forms Level)
                    var section = this.replaceSectionItemsInModel('formSections', 'View Apps', nodes);
                    //var group = this.replaceGroupItemsInModel('formSections', 'View Forms', itemId, nodes);
                    this.addItemsToGroup(section, dataTarget);
                }).catch((error) => {
                    console.log(error);

                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                });
            };

            const _getLibrary = () => {

                // Mght be like _viewForms above
                // API Call to /Forms/Dashboard
                //var dataTarget = ev.currentTarget.attributes['data-target'].value;
                var groupTypeId = itemId;

                RestService.getLibraryForms(groupTypeId).then((data) => {
                    let forms = data.RESULT.RESPONSE.Group;

                    var nodes = [];
                    if (forms) {
                        nodes = this.loadNodesFromResponse(forms, groupTypeId);
                    } else {
                        nodes = [{
                            nodeName: 'no items',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: groupType,
                            nodeType: '',
                            parentId: null,
                            hasChildren: false
                        }]
                    }
                    var group = {
                        nodes: nodes
                    };
                    //var group = this.replaceGroupItemsInModel('formSections', 'Library', itemId, nodes);
                    this.addItemsToSection(group, dataTarget);

                }).then(() => {
                    this.handleSection(ev);
                }).catch((error) => {
                    console.log(error);

                    var msg = error || 'Unknown Error';
                    NotificationService.error(msg);
                });
            };

            const map = {
                'attn': _none,
                'editForms' : _editForms,
                'browseFormInstances': _browseFormInstances,
                'group': _group,
                'viewForms': _viewForms,
                'viewableFormInstance': _browseViewableFormInstances,
                'library': _getLibrary,
                'none': _none
            };

            let node = map[nodeType];
            if (node) {
                (node)();
            }
        }
        else {
            this.handleSection(ev);
            const mapSectionType = {'1': 'editForms', '3': 'viewForms'};
            let sectionName = mapSectionType[itemId];
            this.selectedNodeOnTree = undefined;
            this.selectedNodeTarget = undefined;
            this.selectedGroupType = itemId;
            this.selectedNodeType=sectionName;
        }
        
        listService.avoidDoubleClickOnDashboardTree = false;

        if ((nodeType === 'group' && eventTarget.is('a')) || eventTarget.is('i') || eventTarget.is('h4') || (eventTarget.is('a') && eventTarget.parent().is('h4')) || (eventTarget.is('div') && eventTarget.hasClass('document-heading') )) {
            this.collapseWithoutPropagation(ev);
        }

        this.activateSection(ev);
    }

    renderViewFormNodes(groupTypeId,nodeType,groupType,dataTarget){
        util.cleanChildNodes(dataTarget);
        $('a[data-target="'+ dataTarget + '"] i').toggleClass('pf-carot-left pf-carot-down');
        RestService.getPublishedForms().then((data) => {
            util.enableReloadLink();
            let forms = data.RESULT.RESPONSE.Group;
            var nodes = [];
            if (forms) {
                nodes = this.loadNodesFromResponse(forms, groupTypeId);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    parentId: null,
                    hasChildren: false
                }]
            }

            let group = {
                nodes: nodes
            }

            this.addItemsToSection(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupType;
            this.selectedNodeType=nodeType;
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });

    }

    renderFormInstancesNodes(itemId,formId,isClosed,isArchived,nodeType,groupType,dataTarget){
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        RestService.getFormInstances(formId, isClosed, isArchived).then((data) => {
            util.enableReloadLink();
            let instances = data.RESULT.RESPONSE.InstanceList;
            let nodes = [];
            if (instances) {
                if (instances.Instance) {
                    nodes = this.loadInstancesFromResponse(instances.Instance, groupType);
                } else {
                    nodes = [{
                        nodeName: 'no items',
                        url: '#',
                        icon: ICON_EMPTY,
                        id: 0,
                        groupType: groupType,
                        nodeType: '',
                        hasChildren: false,
                        parentId: null
                    }];
                }
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    hasChildren: false,
                    parentId: null
                }];
            }

            var group = this.replaceGroupItemsInModel('formSections', 'Edit Apps', itemId, nodes);
            this.addItemsToGroup(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupType;
            this.selectedNodeType=nodeType;

            if (_.isEmpty(group)) {
                const $parent = $(`#well${groupType}_${formId}`).parent().closest('div');
                const parentId = $parent.attr('id').split('well')[1];
                this.apiGetFormsByGroupType({groupTypeId:groupType, groupId:parentId, dataTarget:`well${parentId}`, nodeType:constants.FIELD_METADATA_TYPE_GROUP, triggerClick:itemId});
                if (_.isEmpty(group)) {
                    group = {
                        groupType: groupType,
                        hasChildren: true,
                        icon: 'record-placeholder',
                        id: itemId,
                        nodeName: /OPEN_INST/.test(itemId) ? 'Open Instances' : 'Closed Instances',
                        nodeType: 'browseFormInstances',
                        nodes: nodes,
                        parentId: formId,
                        toggleIcon: 'pf-carot-left',
                        url: ''
                    };
                }
                this.addItemsToGroup(group, dataTarget);
            }
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderFolderNodes(groupId,groupTypeId,nodeType,dataTarget){
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        this.apiGetFormsByGroupType({groupTypeId, groupId, dataTarget, nodeType});
    }

    renderLibraryFolderNodes(groupId,groupTypeId,nodeType,dataTarget){
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        RestService.getFormsByGroupType(groupTypeId, groupId).then((data) => {
            util.enableReloadLink();
            this.selectedNodeOnTree = this.renderFormBrowseNodes(groupTypeId,groupId,dataTarget,data,'Edit Apps');
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupTypeId;
            this.selectedNodeType = nodeType;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderFormNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget){
        if(listService.dashboardLayout.mainPanelView.model.get('hasChanges')){

            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`App - ${listService.dashboardLayout.mainPanelView.model.get("formName")}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                   this.processRefreshFormNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget);
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
           this.processRefreshFormNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget);
        }
    }

    renderViewFormNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget,formName){
        util.cleanChildNodes(dataTarget);
        const formId=groupId?.split('_')[1];
        var emptyNode = [{
            nodeName: 'no items',
            url: '#',
            icon: ICON_EMPTY,
            id: 0,
            groupType: groupTypeId,
            nodeType: '',
            parentId: null,
            hasChildren: false
        }];

        RestService.getViewableInstances(formId).then((data) => {
            let instances = data.RESULT.RESPONSE.InstanceList;

            if (instances) {
                var nodes = [];
                if (instances.Instance) {
                    nodes = this.loadInstancesFromResponse(instances.Instance, groupTypeId);
                } else {
                    nodes = emptyNode;
                }


            } else {
                nodes = emptyNode;
            }

            // need base method to replace Section Items in model (Edit Forms/ View Forms Level)
            var section = this.replaceSectionItemsInModel('formSections', 'View Apps', nodes);
            //var group = this.replaceGroupItemsInModel('formSections', 'View Forms', itemId, nodes);
            this.addItemsToGroup(section, dataTarget);
            const name = $(`a[data-itemid="${groupId}"]`).text() || formName;
            this.loadViewableFormInstanceDetails(formId,name);
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    processRefreshFormNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget){
        let formDetailsValues=groupId.split('_');
        util.disableReloadLink();
        RestService.getFormDetails(formDetailsValues[1]).then((formDetailsResult) => {
            util.enableReloadLink();
            this.renderAndBindFormDetailView(formDetailsResult,formDetailsValues[1],groupTypeId,nodeType);
            let activeForm=$('.bg-success');

            if(formDetailsResult.RESULT.RESPONSE.PrivateFormDetails.HasInstances === 'True' &&
                (!$(activeForm.children('i')[0]).hasClass('pf-carot-left') &&
                !$(activeForm.children('i')[0]).hasClass('pf-carot-down')) &&  activeForm.length > 0) {

                $(activeForm.children('i')[0]).addClass('pf-carot-left');
                let element=`
                <div id="well${groupId}" class="bo-body collapse" aria-expanded="false" style="height: 0px;">
                        <ul class="group-items">
                            
                            <li role="button">
                                <i data-toggle="collapse" data-target="#well${formDetailsValues[1]}OPEN_INST" data-itemid="${formDetailsValues[1]}OPEN_INST" data-grouptype="${groupTypeId}" data-nodetype="browseFormInstances" class="switch collapsed pf-carot-left"></i>
                                <a class="item-link" data-itemid="${formDetailsValues[1]}OPEN_INST" data-grouptype="${groupTypeId}" data-nodetype="browseFormInstances" data-parentid="${formDetailsValues[1]}" role="">Open Instances</a>
                            </li>
                
                            
                            <div id="well${formDetailsValues[1]}OPEN_INST" class="bo-body collapse">
                                <ul class="group-items"></ul>
                                </div>
                
                            
                            <li role="button">
                                <i data-toggle="collapse" data-target="#well${formDetailsValues[1]}CLOSED_INST" data-itemid="${formDetailsValues[1]}CLOSED_INST" data-grouptype="${groupTypeId}" data-nodetype="browseFormInstances" class="switch collapsed pf-carot-left"></i>
                                <a class="item-link" data-itemid="${formDetailsValues[1]}CLOSED_INST" data-grouptype="${groupTypeId}" data-nodetype="browseFormInstances" data-parentid="${formDetailsValues[1]}" role="">Closed Instances</a>
                            </li>
                
                            
                            <div id="well${formDetailsValues[1]}CLOSED_INST" class="bo-body collapse">
                                <ul class="group-items"></ul>
                                </div>
                        </ul>
                    </div>`;

                activeForm.after(element);
                let mainFormSection=this.model.get('formSections')
                let currentNodes=mainFormSection.sections[0].groups[0].nodes;
                let currentElementIndex=_.findIndex(currentNodes,function(el){
                    return el.nodeName === formDetailsResult.RESULT.RESPONSE.PrivateFormDetails.Name;
                })
                console.log('currentElementIndex',currentElementIndex);

                if (currentNodes && currentNodes.length > 0) {
                    currentNodes[currentElementIndex].hasChildren = true;
                    currentNodes[currentElementIndex].nodes.push({
                        nodeName: 'Open Instances',
                        url: '',
                        icon: '',
                        id: formDetailsValues[1] + 'OPEN_INST',
                        groupType: groupTypeId,
                        nodeType: 'browseFormInstances',
                        hasChildren: true,
                        parentId: formDetailsValues[1],
                        toggleIcon: 'pf-carot-left'
                    },
                        {
                            nodeName: 'Closed Instances',
                            url: '',
                            icon: '',
                            id: formDetailsValues[1] + 'CLOSED_INST',
                            groupType: groupTypeId,
                            nodeType: 'browseFormInstances',
                            hasChildren: true,
                            parentId: formDetailsValues[1],
                            toggleIcon: 'pf-carot-left'
                        });
                }
            }
            else if(formDetailsResult.RESULT.RESPONSE.PrivateFormDetails.HasInstances === 'True' &&  activeForm.length > 0 &&
                util.isElementExpanded($($(activeForm.children('i')[0]).attr('data-target')))){
                const idOpenToCollapseSelector='#well'+$(activeForm.children('i')[0]).attr('data-target').split('_')[1]+'OPEN_INST';
                const idCloseToCollapseSelector='#well'+$(activeForm.children('i')[0]).attr('data-target').split('_')[1]+'CLOSED_INST';
                $(idOpenToCollapseSelector).collapse('hide');
                $(idCloseToCollapseSelector).collapse('hide');
                $(`i[data-target='${idOpenToCollapseSelector}']`).removeClass('pf-carot-down').addClass('pf-carot-left');
                $(`i[data-target='${idCloseToCollapseSelector}']`).removeClass('pf-carot-down').addClass('pf-carot-left');
            }
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            let msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    renderFormInstancesNodeAndDetail(groupId,groupTypeId,nodeType,dataTarget){
        const isClosed = ( new RegExp('CLOSED').test(groupId) ) ? true : false;
        const isArchived = false;
        const formId = groupId.replace('OPEN_INST', '').replace('CLOSED_INST', '');
        const formName = isClosed ? 'Closed Instances':'Open Instances';
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        RestService.getFormInstances(formId, isClosed, isArchived).then((data) => {
            util.enableReloadLink();
            let instances = data.RESULT.RESPONSE.InstanceList;
            let nodes = [];
            if (instances) {
                if (instances.Instance) {
                    nodes = this.loadInstancesFromResponse(instances.Instance, groupTypeId);
                } else {
                    nodes = [{
                        nodeName: 'no items',
                        url: '#',
                        icon: ICON_EMPTY,
                        id: 0,
                        groupType: groupTypeId,
                        nodeType: '',
                        hasChildren: false,
                        parentId: null
                    }];
                }


            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupTypeId,
                    nodeType: '',
                    hasChildren: false,
                    parentId: null
                }];
            }

            var group = this.replaceGroupItemsInModel('formSections', 'Edit Apps', groupId, nodes);
            this.addItemsToGroup(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupTypeId;
            this.selectedNodeType=nodeType;
            this.reloadFormInstancesDetailView(groupId,isClosed ? "Closed Instances" : "Open Instances");
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });

    }

    renderViewFormsNodeAndDetail(itemId,groupType,nodeType,dataTarget){
        this.killDetailView();
        util.disableReloadLink()
        const requestParamsObject = {
            includeRecentPlayedForms: 'true',
            includeAllPlayableForms: 'true',
            includeFavoriteForms: 'true'
        };
        RestService.getDashboardDetails(requestParamsObject).then((data)=> {
            util.enableReloadLink();
            this.renderAndBindViewFormsDetailView(data);
            const groupTypeId = itemId;
            this.renderViewFormNodes(groupTypeId,nodeType,groupType,dataTarget);
        }).catch((err)=> {
            util.enableReloadLink();
            console.log("An error has ocurred", err);
        });
    }

    renderLibraryForms(itemId,groupType,nodeType,dataTarget){
        // Mght be like _viewForms above
        // API Call to /Forms/Dashboard
        let groupTypeId = itemId;
        util.cleanChildNodes(dataTarget);
        $('a[data-target="'+ dataTarget + '"] i').toggleClass('pf-carot-left pf-carot-down');
        util.disableReloadLink();
        RestService.getLibraryForms(groupType,groupTypeId).then((data) => {
            util.enableReloadLink();
            let forms = data.RESULT.RESPONSE.Group;
            var nodes = [];
            if (forms) {
                nodes = this.loadNodesFromResponse(forms, groupTypeId);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    parentId: null,
                    hasChildren: false
                }]
            }
            var group = {
                nodes: nodes
            };
            //var group = this.replaceGroupItemsInModel('formSections', 'Library', itemId, nodes);
            this.addItemsToSection(group, dataTarget);
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    // Override Base for Specific Handling
    handleSection(ev) {
        if(this.detailView) {
            const applyChangesElement = $('#applyChangesForm'),
                confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.',
                subtitle = `App - ${this.detailView.model.get('formName')}`;

            util.showConfirmationDashboardChangesModal(applyChangesElement, this.processHandleSection, confirmationText, subtitle, ev,this);
        }
        else{
            this.processHandleSection(ev);
        }
    }

    processHandleSection(ev, overrideSectionType = undefined){
        const sectionType = overrideSectionType
            || ev.currentTarget.attributes['data-nodeType'].value;

        if (ev) {
            super.handleSection(ev);
        }

        const _none = () => {
        };

        const _editFormsDashboard = () => {
            this.renderEditFormsDashboard(ev);
        };

        const _viewFormsDashboard = () => {
            this.renderViewFormsDashboard(ev);
        };


        const map = {
            'sectionEditForms': _editFormsDashboard,
            'editForms': _editFormsDashboard,
            'sectionViewForms': _viewFormsDashboard,
            'viewForms': _viewFormsDashboard,
            'library' : _none,
            'sectionLibrary': _none
        };

        if (sectionType in map) { (map[sectionType])(); }
    }

    renderEditFormsDashboard(refreshTree) {

        const _self = this;

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        this.killDetailView();
        util.disableReloadLink();
        const requestParamsObject = {
            includeRecentManagedForms: 'true',
            includeAllManagedForms: 'true',
            includeFavoriteForms: 'true'
        };

        let formDetailsModel = new FormDetailsModel();
        RestService.getDashboardDetails(requestParamsObject).then((data)=> {
            util.enableReloadLink();
            let currentFavoritesList = [];
            let recentForms = [];
            let formInstances = [];

            let allManagedForms = data.RESULT.RESPONSE.allManagedForms;
            let recentManagedForms = data.RESULT.RESPONSE.recentManagedForms;
            let favoriteForms = data.RESULT.RESPONSE.favoriteForms;

            if (allManagedForms && allManagedForms.form) {
                formInstances = allManagedForms.form instanceof Array
                    ? allManagedForms.form : [allManagedForms.form];
            }

            if (recentManagedForms && recentManagedForms.form) {
                recentForms = recentManagedForms.form instanceof Array
                    ? recentManagedForms.form : [recentManagedForms.form];
            }

            if (favoriteForms && favoriteForms.form) {
                currentFavoritesList = favoriteForms.form instanceof Array
                    ? favoriteForms.form : [favoriteForms.form];
            }

            formDetailsModel.set('recentForms', recentForms);
            formDetailsModel.set('formInstances', formInstances);
            formDetailsModel.set('currentFavoritesList', currentFavoritesList);

            this.killDetailView(false, true);
            let newDashboardView = new EditFormsDashboardView({model: formDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
            listService.dashboardLayout.mainPanelView=newDashboardView;
            this.detailView = newDashboardView;
            this.detailView.render();
            let persistedFormId=RestService.getSelectedFormInEditFormDashboard();
            if(persistedFormId){
                let element=$(`#ddFrmDashInstances > li[formid="${persistedFormId}"]`)
                if(persistedFormId !=='all'){
                    this.getFormInstances(persistedFormId,element);
                }
                else{
                    this.getAllFormInstances(element);
                }
            }

            listService.avoidDoubleClickOnDashboardTree = false;

            if(refreshTree){
                if (listService.dashboardLayout.leftPanelView.selectedNodeType === constants.FORMS_PRIVATE_SECTION) {
                    setTimeout(function() {
                        eventBus.trigger(constants.EV_REFRESH_PRIVATE_NODES,
                                         constants.FORMS_PRIVATE_GROUP_TYPE,
                                         constants.EDIT_FORMS_CONTAINER,
                                         constants.FORMS_PRIVATE_SECTION, 
                                         { isOutsideEvent: true });
                    }, 10);
                }
            }
        }).catch((err)=> {
            util.enableReloadLink();
            console.log("An error has ocurred", err);
        });
    }

    renderViewFormsDashboard(ev) {
        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        const _self = this;

        listService.avoidDoubleClickOnDashboardTree = true;

        this.killDetailView();

        const requestParamsObject = {
            includeRecentPlayedForms: 'true',
            includeAllPlayableForms: 'false',
            includeFavoriteForms: 'true'
        };

        RestService.getDashboardDetails(requestParamsObject).then((data)=> {
            this.renderAndBindViewFormsDetailView(data);
            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((err)=> {
            console.log("An error has ocurred", err);
        });
    }

    renderAndBindViewFormsDetailView(data){
        let recentForms = [];
        let formInstances = [];
        let favoriteForms = [];
        let formDetailsModel = new FormDetailsModel();
        let allPlayableForms = data.RESULT.RESPONSE.allPlayableForms;
        let recentPlayedForms = data.RESULT.RESPONSE.recentPlayedForms;
        let allFavoriteForms = data.RESULT.RESPONSE.favoriteForms;

        if (allPlayableForms && allPlayableForms.form) {
            formInstances = util.processArrayResult(allPlayableForms, 'form');
        }

        if (recentPlayedForms && recentPlayedForms.form) {
            recentForms = util.processArrayResult(recentPlayedForms, 'form');
        }

        if (allFavoriteForms && allFavoriteForms.form) {
            favoriteForms = util.processArrayResult(allFavoriteForms, 'form');
        }

        formDetailsModel.set('recentForms', recentForms);
        formDetailsModel.set('formInstances', formInstances);
        formDetailsModel.set('currentFavoritesList', favoriteForms);

        this.killDetailView(false, true);
        let newViewFormsDashboard = new ViewFormsDashboardView({model: formDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
        listService.dashboardLayout.mainPanelView=newViewFormsDashboard;
        this.detailView = newViewFormsDashboard;
        this.detailView.render();
    }

    handleSelectedGroup(ev) {
        if(this.detailView) {
            const applyChangesElement = $('#applyChangesForm'),
                confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.',
                subtitle = `App - ${this.detailView.model.get('formName')}`;

            util.showConfirmationDashboardChangesModal(applyChangesElement, this.processHandleSelectedGroup, confirmationText, subtitle, ev,this);
        }
        else{
            this.processHandleSelectedGroup(ev);
        }
    }

    processHandleSelectedGroup(ev){
        let itemSelected = $(ev.currentTarget).parent().find('.bg-success');
        if (itemSelected.length > 0) {
            listService.dashboardFormsItems
                .setDefaultValue();
        }

        var sectionType = ev.currentTarget.attributes['data-nodeType'].value;
        var id = ev.currentTarget.attributes['data-groupid'].value;

        if (!$(ev.target).parent().is('a')) {
            this.removeItemGroupSelection();
            $(ev.currentTarget).addClass('bg-success');

        }

        if (util.isTrue(userService.checkPermissions('folders'))){
            $('#createFolder').parent('li').removeClass('li-disabled');
        }else{
            $('#createFolder').parent('li').addClass('li-disabled');
        }

        if (sectionType === constants.FORMS_PRIVATE_SECTION || sectionType === constants.FORMS_SHARED_SECTION) {
            const groupTypeId = id;
            const dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
            const icon = $('a[data-target="' + dataTarget + '"] i');
            const target = $(ev.currentTarget).find('.switch');

            util.togglePanel(target, icon);

            // if classname of children[1] contains 'collapsed' then ignore , only load on expand.
            if (new RegExp('collapsed').test(ev.currentTarget.children[1].className)) {
                this.loadPrivateOrSharedForms(groupTypeId,dataTarget,sectionType);
            }
            else {
                this.selectedNodeOnTree = undefined;
                this.selectedNodeTarget = undefined;
                this.selectedGroupType = groupTypeId;
                this.selectedNodeType = sectionType;
                this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
                this.selectedNodeParentId = constants.DEFAULT_GROUP_ID;
            }

            this.activateSection(ev);
        }
    }

    loadPrivateOrSharedForms(groupTypeId,dataTarget,sectionType, ev = {}){
        if (listService.avoidDoubleClickOnDashboardTree &&
            (ev && !ev.isOutsideEvent)) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        const that = this;
        util.cleanChildNodes(dataTarget);
        util.disableReloadLink();
        RestService.getFormsByGroupType(groupTypeId).then((data) => {
            util.enableReloadLink();
            let forms = data.RESULT.RESPONSE.Group;
            let nodes = this.loadNodesFromResponse(forms, groupTypeId);
            that.originalResponse = nodes;

            // Update Model So It Will Be There Later, duh.
            let group = this.replaceGroupItemsInModel('formSections', 'Edit Apps', groupTypeId, nodes);
            
            this.addItemsToGroup(group, dataTarget);
            this.selectedNodeOnTree = group.id;
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupTypeId;
            this.selectedGroupParentId = constants.DEFAULT_GROUP_ID;
            this.selectedNodeType = sectionType;

            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            const msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    handleDblSelectedGroupItem(ev) {

        const target = $(ev.currentTarget);

        const nodeType = target.attr('data-nodetype');
        const groupType = target.attr('data-grouptype');
        //Main folders in Shared
        const isUser = target.attr('data-isuser') === 'user' || target.attr('data-isuser') === 'otheruser';
        const innerText = target.text();
        const formsInViewForms = '3';
        const formsInLibrary = '0';

        if (groupType === formsInLibrary || groupType === formsInViewForms || isUser) {
            return;
        }

        if (ev.type === 'dblclick' && nodeType !== '' && nodeType !== 'browseFormInstances' && nodeType !== 'editFormInstance' && innerText !== '') {

            try {
                ev.preventDefault();
            } catch (e) {
                console.log("error", e);
            }

            localStorage.setItem('oriVal', innerText);
            target.text('');
            $(util.inputRenameTree(innerText)).appendTo(target).focus().select();
        }

        return false;
    }

    handleFocusOut(ev){

        var $this = $(ev.currentTarget);
        var parent=$this.parent();
        let groupId=parent.attr('data-itemid');
        let idForm=parent.attr('data-itemid').split('_')[1] || parent.attr('data-itemid');
        let groupType=parent.attr('data-grouptype');
        let originalValue = localStorage.getItem('oriVal').trim();
        const formName=$this.val().trim() || originalValue;
        const nodeType = parent.data('nodetype');
        $this.parent().text(formName);
        let id = nodeType === 'group' ? idForm : groupType + "_"+ idForm;
        let link = $('a[data-itemid="'+id +'"]');
        link.prop('title', formName);

        const updateResponse = (msg, status) => {
            if (status === 'success') {
                NotificationService.success(msg);
            } else {
                NotificationService.error(msg);
            }
            $('#dashboard-left-panel .item-link').prop('disabled', false);
        }

        if ($this.val().trim() !== originalValue) {
            if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
                $('#dashboard-left-panel .item-link').prop('disabled', true);
                // PF-3892: Renaming folder
                if ( nodeType === 'group' ) {

                    RestService.renameFolder({idFolder:idForm, newName:formName, isForm:true}).then(data => {
                        updateResponse(data.msg, 'success');
                    }, err => {
                        updateResponse(data.msg, 'error');
                    });

                    UndoService.add({
                        undo:() => {
                            RestService.renameFolder({idFolder:idForm, newName:originalValue, isForm:true}).then(data => {
                                    let anchorToUpdate = $(`a[title="${formName}"]`);
                                    anchorToUpdate.text(originalValue);
                                    anchorToUpdate.prop('title', originalValue);
                                    updateResponse(data.msg, 'success');
                                },
                                err => {
                                    updateResponse(data.msg, 'error');
                                });
                        },
                        redo:() => {
                            RestService.renameFolder({idFolder:idForm, newName:formName, isForm:true}).then(data => {
                                    let anchorToUpdate = $(`a[title="${originalValue}"]`);
                                    anchorToUpdate.text(formName);
                                    anchorToUpdate.prop('title', formName);
                                    updateResponse(data.msg, 'success');
                                },
                                err => {
                                    updateResponse(data.msg, 'error');
                                });
                        }
                    },textConstants.UNDO_RENAME_FOLDER);
                } else { // renaming form
                    RestService.updateFormName(idForm, formName).then(data => {
                        updateResponse('App succesfuly renamed.', 'success');
                        eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, idForm, groupType, groupId);
                    }, err => {
                        updateResponse(data.msg, 'error');
                    });

                    UndoService.add({
                        undo:() => {
                            RestService.updateFormName(idForm, originalValue).then(data => {
                                let anchorToUpdate = $(`a[title="${formName}"]`);
                                anchorToUpdate.text(originalValue);
                                anchorToUpdate.prop('title', originalValue);
                                updateResponse('App succesfuly restored.', 'success');
                                eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, idForm, groupType, groupId);
                            }, err => {
                                updateResponse(data.msg, 'error');
                            });
                        },
                        redo:() => {
                            RestService.updateFormName(idForm, formName).then(data => {
                                let anchorToUpdate = $(`a[title="${originalValue}"]`);
                                anchorToUpdate.text(formName);
                                anchorToUpdate.prop('title', formName);
                                updateResponse('App succesfuly renamed.', 'success');
                                eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, idForm, groupType, groupId);
                            }, err => {
                                updateResponse(data.msg, 'error');
                            });
                        }
                    },textConstants.UNDO_RENAME_FORM);
                }
            }
        }
        $this.remove();
    }

    handleEnter(ev){
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
            $(ev.currentTarget).blur();
        }
    }

    handleSelectedGroupItem(ev) {
        let eventTarget = $(ev.target);
        let currentSection = eventTarget.data('nodetype');
        let groupType = eventTarget.data('grouptype');
        if(currentSection === 'viewForms'){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").removeClass('li-disabled');
            $("#createPersonalFolder").removeClass('li-disabled');
        }
        else{
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $(".user-list-private").removeClass('hide');
            $(".user-list-view").addClass('hide');
        }
        if(groupType === constants.ACCOUNT_FOLDER_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().removeClass('li-disabled');
            $("#createPersonalFolder").parent().addClass('li-disabled');
        }
        else if(groupType === constants.PERSONAL_FOLDER_GROUP_TYPE ){
            $(".user-list-private").addClass('hide');
            $(".user-list-view").removeClass('hide');
            $("#createAccountFolder").parent().addClass('li-disabled');
            $("#createPersonalFolder").parent().removeClass('li-disabled');
        }

        let spinner=$(".spinner").is(":visible");
        if (ev.type !== 'dblclick' && (!spinner) ) {
            try {
                ev.preventDefault();
            } catch (e) {
                console.log(e);
            }

            if (this.detailView) {
                const applyChangesElement = $('#applyChangesForm'),
                    confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.',
                    subtitle = `App - ${this.detailView.model.get('formName')}`;

                util.showConfirmationDashboardChangesModal(applyChangesElement, this.openGroupDetailView, confirmationText, subtitle, ev,this);
            }
            else{
                this.openGroupDetailView(ev);
            }

            this.activateSection(ev);
        }
    }

    openGroupDetailView(ev){
        var itemId = ev.currentTarget.attributes['data-itemid'].value;
        var groupType = ev.currentTarget.attributes['data-groupType'].value;
        var nodeType = ev.currentTarget.attributes['data-nodeType'].value;
        var parentId = ev.currentTarget.attributes['data-parentId'].value;
        this.linkId =ev.currentTarget.attributes['data-linkid'].value;
        let formTreeData=$(ev.currentTarget).siblings('i');

        const refreshButton = $('#pf-refresh-main-view'); //reset id in refresh button
        refreshButton.attr("data-appid", itemId.substring(2));    

        if (nodeType !== 'group'){
            if (!$('#createFolder').parent('li').hasClass('li-disabled')) {
                $('#createFolder').parent('li').addClass('li-disabled');
            }
        }else{
            if ($('#createFolder').parent('li').hasClass('li-disabled')) {
                $('#createFolder').parent('li').removeClass('li-disabled');
            }
        }

        // This check is performed when an item is selected on the tree that is not a folder.
        if($(ev.currentTarget).siblings('span').hasClass( constants.DB_ICON_EMPTY )){
            let parent=$(ev.currentTarget).parents('div')[0];
            this.selectedNodeOnTree=$(parent).attr('id').substring(4);
            this.selectedNodeTarget='#'+$(parent).attr('id');
            this.selectedNodeParentId= parentId;
        }
        else {
            this.selectedNodeOnTree = $(formTreeData).attr('data-itemid').indexOf('_') > 0
                ? $(formTreeData).attr('data-itemid').substring(2)
                : $(formTreeData).attr('data-itemid');
            this.selectedNodeTarget = $(formTreeData).attr('data-target');
            this.selectedNodeParentId= parentId;
        }

        this.selectedGroupType =  groupType;
        this.selectedNodeType =  nodeType;
        this.selectedGroupParentId = this.selectedNodeOnTree;

        var otherData = ev.currentTarget.attributes['data-other'] ? ev.currentTarget.attributes['data-other'].value : '';
        var formName = $(ev.currentTarget).text();

        this.removeItemGroupSelection();

        if ($(ev.target).parents('#well_2').length > 0 || $(ev.target).parents('#well_3').length > 0 || $(ev.target).parents('#well_4').length > 0) {
            this.retrieveFormNodes(ev, false);
        }

        this.addItemGroupSelection(ev.currentTarget);

        const _none = () => {};

        const _attn = () => {
            this.killDetailView();
            //if(this._checkIsFolder(node)){return;}
            //const itemId = node.groupId || node.viewFormsId || node.editFormsId;

            var formId = itemId.substring(2);
            this.reloadFormDetails(formId, groupType, itemId);
        };

        const _getFormInstances = () => {
           this.reloadFormInstancesDetailView(itemId,formName);
        };

        const _getEditFormInstanceDetail = () => {
            this.renderEditFormsViewableInstanceDetailView(itemId, otherData);
        };

        const _getViewFormInstance = () => {
            this.renderViewableInstanceDetailView(itemId, otherData);
        };

        const _searchViewableFormInstances = () => {
            const formId = itemId.split('_')[1];
            this.loadViewableFormInstanceDetails(formId, formName);
        };

        const _libraryDetails = () => {
            this.killDetailView();
            const libraryId = itemId.split('_')[1];
            this.renderLibraryDetails(libraryId);
        };
 
        const map = {
            'group' : _none,
            'attn': _attn,
            'editFormInstance': _getEditFormInstanceDetail,
            'browseFormInstances': _getFormInstances,
            'viewFormInstance': _getViewFormInstance,
            'viewableFormInstance': _searchViewableFormInstances,
            'libraryForms': _libraryDetails
        };

        let node = map[nodeType];
        if (node) {
            (node)();
        }
    }

    reloadFormInstancesDetailView(itemId,formName){
        var isClosed = ( new RegExp('CLOSED').test(itemId) ) ? true : false;
        var title = isClosed ? 'Closed' : 'Open';

        this.killDetailView();

        let formId = itemId.replace('OPEN_INST', '').replace('CLOSED_INST', '');

        let formDetailsModel = new FormDetailsModel();

        // Configure Title and Breadcrumbs
        let breadcrumbs = [
            {name: 'Forms', route: '#forms', id: "goToForms"},
            {name: 'Edit App', route: '#forms', id: "goToEditForms"},
            {name: formName, route: ''}
        ];

        formDetailsModel.set({
            'dashboardTitle': title + ' Instances - ' + formName,
            'breadcrumbs': breadcrumbs,
            'formId': formId,
            status: isClosed ? "1" : "0"
        });
        // **************************

        let newFormInstancesView=new FormInstancesView({
            model: formDetailsModel,
            el: constants.DASHBOARD_MAIN_PANEL,
            closed: isClosed
        });
        listService.dashboardLayout.mainPanelView=newFormInstancesView;
        this.detailView = newFormInstancesView;
        this.detailView.render();
    }

    renderLibraryDetails(libraryId){
        util.disableReloadLink();
        RestService.getLibraryDetails(libraryId).then((libraryDetails)=> {
            util.enableReloadLink();
            let libraryDetailsModel = new LibraryDetailsModel();
            libraryDetailsModel.set('name', libraryDetails.Name);
            libraryDetailsModel.set('isActive', libraryDetails.IsActive);
            libraryDetailsModel.set('type', libraryDetails.Type);
            libraryDetailsModel.set('hasForm', libraryDetails.HasForm);
            libraryDetailsModel.set('isSpecial', libraryDetails.IsSpecial);
            libraryDetailsModel.set('libraryId', libraryId);


            //// Configure Title and Breadcrumbs
            let breadcrumbs = [
                {name: 'Apps', route: '#forms', id:'goToForms'},
                {name: 'Library', route: ''}
            ];

            libraryDetailsModel.set('dashboardTitle', 'Library Details - ' + libraryDetails.Name);
            libraryDetailsModel.set('breadcrumbs', breadcrumbs);


            let libraryData = XJService.toJSON(libraryDetails.LibraryXML['#cdata-section']).LibraryForm;
            console.log("LibraryData", libraryData);
            let images = libraryData.Assets.Asset instanceof Array ? libraryData.Assets.Asset : [libraryData.Assets.Asset];
            if(images[0]){
                images = images.map((image)=> {
                    return RestService.getAssetURL(image._id);
                });
            }
            libraryDetailsModel.set('libraryData', libraryData);
            libraryDetailsModel.set('images', images);
            let currentPageModel = libraryData.Pages.Page instanceof Array ? libraryData.Pages.Page[0] : libraryData.Pages.Page;
            console.log("Current Description", currentPageModel);
            libraryDetailsModel.set('currentPage', currentPageModel);
            let newLibraryDetailsView=new LibraryDetailsView({
                model: libraryDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            listService.dashboardLayout.mainPanelView=newLibraryDetailsView;
            this.detailView = newLibraryDetailsView;
            this.detailView.render();

        }).catch((error) => {
            util.enableReloadLink();
            console.log(error);
            var msg = error || 'Error while loading library details';
            NotificationService.error(msg);
        });
    }

    renderViewableInstanceDetailView(instanceId, formInstanceId,reloadNodes=false) {
        this.killDetailView();
        let viewableInstanceDetailModel = new ViewableInstanceDetailModel();
        RestService.getViewableInstanceDetails(instanceId).then((data)=> {
            const viewableInstanceDetails = data.RESULT.RESPONSE;
            console.log('Details', viewableInstanceDetails);
            let notificationList = [];

            viewableInstanceDetailModel.set('formInstanceId', formInstanceId, {silent: true});
            viewableInstanceDetailModel.set('instanceId', instanceId, {silent: true});
            viewableInstanceDetailModel.set('name', viewableInstanceDetails.Name, {silent: true});
            viewableInstanceDetailModel.set('formName', viewableInstanceDetails.FormName, {silent: true});
            viewableInstanceDetailModel.set('version', viewableInstanceDetails.MajorVersion + '.' + viewableInstanceDetails.MinorVersion, {silent: true});
            viewableInstanceDetailModel.set('firstSubmissionDate', util.toLocalDateTime(viewableInstanceDetails.FirstSubmissionDate, 'DD MMM YYYY'), {silent: true});
            viewableInstanceDetailModel.set('lastSubmissionDate', util.toLocalDateTime(viewableInstanceDetails.LastSubmissionDate, 'DD MMM YYYY'), {silent: true});
            viewableInstanceDetailModel.set('stage', viewableInstanceDetails.StageName, {silent: true});
            viewableInstanceDetailModel.set('status', viewableInstanceDetails.IsClosed === 'False' ? 'Open' : 'Closed', {silent: true});
            viewableInstanceDetailModel.set('myAttentionLevel', util.getAttentionLevel(viewableInstanceDetails.UserAttentionLevel), {silent: true});
            viewableInstanceDetailModel.set('otherAttentionLevel', util.getAttentionLevel(viewableInstanceDetails.OtherAttentionLevel), {silent: true});

            console.log(`firstSubmissionDate: ${viewableInstanceDetailModel.get('firstSubmissionDate')}`);
            console.log(`lastSubmissionDate: ${viewableInstanceDetailModel.get('lastSubmissionDate')}`);

            if (viewableInstanceDetails.NotificationList) {
                notificationList = viewableInstanceDetails.NotificationList.Notification instanceof Array
                    ? viewableInstanceDetails.NotificationList.Notification
                    : [viewableInstanceDetails.NotificationList.Notification];
            }
            viewableInstanceDetailModel.set('gridData', notificationList, {silent: true});

            // Configure Title and Breadcrumbs
            var breadcrumbs = [
                {name: 'Apps', route: '#forms', id: "goToForms"},
                {name: 'Edit App', route: '#forms', id: "goToEditForms"},
                {name: viewableInstanceDetails.FormName, route: ''}
            ];

            viewableInstanceDetailModel.set('dashboardTitle', 'App Instance - ' + viewableInstanceDetails.FormName);
            viewableInstanceDetailModel.set('breadcrumbs', breadcrumbs);
            // **************************
            let newViewableInstanceDetailView=new ViewableInstanceDetailView({
                model: viewableInstanceDetailModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            listService.dashboardLayout.mainPanelView=newViewableInstanceDetailView;
            this.detailView = newViewableInstanceDetailView;
            this.detailView.render();
        });
    }

    renderEditFormsViewableInstanceDetailView(instanceId, formInstanceId) {

        this.killDetailView();
        let viewableInstanceDetailModel = new ViewableInstanceDetailModel();
        util.disableReloadLink();
        RestService.getOpenInstanceViewDetails(instanceId).then((data)=> {
            util.enableReloadLink();
            const viewableInstanceDetails = data.RESULT.RESPONSE;
            console.log('Details', viewableInstanceDetails);
            let notificationList = [], historyXML = [];
            viewableInstanceDetailModel.set('instanceId', instanceId, {silent: true});
            viewableInstanceDetailModel.set('formInstanceId', formInstanceId, {silent: true});
            viewableInstanceDetailModel.set('name', viewableInstanceDetails.Name, {silent: true});
            viewableInstanceDetailModel.set('formName', viewableInstanceDetails.FormName, {silent: true});
            viewableInstanceDetailModel.set('version', viewableInstanceDetails.MajorVersion + '.' + viewableInstanceDetails.MinorVersion, {silent: true});
            viewableInstanceDetailModel.set('firstSubmissionDate', util.toLocalDateTime(viewableInstanceDetails.FirstSubmissionDate, 'DD MMM YYYY'), {silent: true});
            viewableInstanceDetailModel.set('lastSubmissionDate', util.toLocalDateTime(viewableInstanceDetails.LastSubmissionDate, 'DD MMM YYYY'), {silent: true});
            viewableInstanceDetailModel.set('lastPerson', viewableInstanceDetails.LastSubmissionUserName, {silent: true});
            viewableInstanceDetailModel.set('stage', viewableInstanceDetails.StageName, {silent: true});
            viewableInstanceDetailModel.set('status', viewableInstanceDetails.IsClosed === 'False' ? 'Open' : 'Closed', {silent: true});

            let instanceItemSelected = {
                id: instanceId,
                name: viewableInstanceDetails.Name,
                formId: formInstanceId
            };

            listService.dashboardFormsItems
                .setDefaultValue()
                .setPropValue('instanceItemSelected', instanceItemSelected);

            if (viewableInstanceDetails.NotificationList) {
                notificationList = viewableInstanceDetails.NotificationList.Notification instanceof Array
                    ? viewableInstanceDetails.NotificationList.Notification
                    : [viewableInstanceDetails.NotificationList.Notification];
            }
            viewableInstanceDetailModel.set('notificationData', notificationList, {silent: true});

            if (viewableInstanceDetails.HistoryXML) {
                historyXML = viewableInstanceDetails.HistoryXML.Action instanceof Array
                    ? viewableInstanceDetails.HistoryXML.Action
                    : [viewableInstanceDetails.HistoryXML.Action];
            }
            viewableInstanceDetailModel.set('historyData', historyXML, {silent: true});


            // Configure Title and Breadcrumbs
            var breadcrumbs = [
                {name: 'Apps', route: '#forms', id: "goToForms"},
                {name: 'Edit App', route: '#forms', id: "goToEditForms"},
                {name: viewableInstanceDetails.FormName, route: ''}
            ];

            viewableInstanceDetailModel.set('dashboardTitle', 'App Instance - ' + viewableInstanceDetails.FormName);
            viewableInstanceDetailModel.set('breadcrumbs', breadcrumbs);
            // **************************

            let newEditFormsViewableInstanceDetailView = new EditFormsViewableInstanceDetailView({
                model: viewableInstanceDetailModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newEditFormsViewableInstanceDetailView;
            this.detailView = newEditFormsViewableInstanceDetailView;
            this.detailView.render();

        }).catch((error) => {
            util.enableReloadLink();
            console.log(error);
            var msg = error || 'Error while loading instance details';
            NotificationService.error(msg);
        });
    }

    loadInstancesFromResponse(instances, groupType) {
        var nodes = [];

        if (instances instanceof Array) {
            for (let instance of instances) {
                nodes.push(
                    {
                        nodeName: instance['@Name'] + ' ' + util.getFormattedDate(instance['@LastSubmissionDate']),
                        icon: ICON_EMPTY,
                        nodes: [],
                        isDraft:instance['@IsDraft'] ? instance['@IsDraft'] : instance['@IsDraft'],
                        id: instance['@id'] ? instance['@id'] : instance['@Id'],
                        groupType: groupType,
                        nodeType: groupType === constants.FORMS_VIEW_GROUP_TYPE ? 'viewFormInstance' : 'editFormInstance',
                        hasChildren: false,
                        toggleIcon: '',
                        parentId: null,
                        otherData: instance['@FormInstanceId']
                    });

            }
        }
        else {
            nodes.push(
                {
                    nodeName: instances['@Name'] + ' ' + util.getFormattedDate(instances['@LastSubmissionDate']),
                    icon: ICON_EMPTY,
                    nodes: [],
                    isDraft:instances['@IsDraft'] ? instances['@IsDraft'] : instances['@IsDraft'],
                    id: instances['@id'] ? instances['@id'] : instances['@Id'],
                    groupType: groupType,
                    nodeType: groupType === constants.FORMS_VIEW_GROUP_TYPE ? 'viewFormInstance' : 'editFormInstance',
                    hasChildren: false,
                    toggleIcon: '',
                    parentId: null,
                    otherData: instances['@FormInstanceId']
                });
        }

        return nodes;
    }

    loadNodesFromResponse(forms, groupType, selectedId) {
        var nodes = [];
        var itemNodeType = '';

        if (groupType === constants.FORMS_PRIVATE_GROUP_TYPE) {
            itemNodeType = 'attn';
        }
        if (groupType === constants.FORMS_SHARED_GROUP_TYPE) {
            itemNodeType = 'attn';
        }
        if (groupType === constants.FORMS_VIEW_GROUP_TYPE) {
            itemNodeType = 'viewableFormInstance';
        }
        if (groupType === constants.FORMS_LIBRARY_GROUP_TYPE) {
            itemNodeType = 'libraryForms';
        }

        // Need to handle Folders
        if ( forms && forms.Group ) {
            // Folders always call /App/Browse
            // Checking whether is an Array or an object so we can loop the items
            // or access the single object properties

            if (forms.Group instanceof Array) {

                for (let group of forms.Group) {
                    let iconFolder = ICON_FOLDER;
                    if(group['@type'] === constants.ACCOUNT_FOLDER_GROUP_TYPE || groupType === constants.ACCOUNT_FOLDER_GROUP_TYPE ){
                        iconFolder = ICON_FOLDER_ACCOUNT;
                    }
                    // pf-5131 Dashboard - Error when opening shared folder
                    let fixedGroupType = group['@type'] || groupType;
                    if (group['@type']=== 'normal' || group['@type']=== 'user' || group['@type']=== 'otheruser' ){
                        fixedGroupType = groupType;
                    }
                    nodes.push(
                        {
                            nodeName: group['@name'],
                            icon: iconFolder,
                            nodes: [],
                            id: group['@id'] || group['@groupId'],
                            groupType: fixedGroupType,
                            nodeType: 'group',
                            hasChildren: true,
                            parentId: group['@id'] || group['@groupId'],
                            isUserType: group['@type'],
                            toggleIcon: 'pf-carot-left'
                        });
                }
            }
            else {
                var hasChildren = false;
                if (forms.Group['@hasChildren']) {
                    if (forms.Group['@hasChildren'].toString().toLowerCase() === 'true') {
                        hasChildren = true;
                    }
                }


                let iconFolder = ICON_FOLDER;
                if(forms.Group['@type'] === constants.ACCOUNT_FOLDER_GROUP_TYPE || groupType === constants.ACCOUNT_FOLDER_GROUP_TYPE ){
                    iconFolder = ICON_FOLDER_ACCOUNT;
                }

                nodes.push(
                    {
                        nodeName: forms.Group['@name'],
                        icon: iconFolder,
                        nodes: [],
                        id: forms.Group['@groupId'] ? forms.Group['@groupId'] : forms.Group['@id'],
                        groupType: groupType,
                        nodeType: 'group',
                        isUserType: forms.Group['@type'],
                        hasChildren: hasChildren,
                        parentId: forms.Group['@groupId'] ? forms.Group['@groupId'] : forms.Group['@id'],
                        toggleIcon: hasChildren ? 'pf-carot-left' : ''
                    });
            }


        }

        // This will do Items. Not only the item will be an array.
        if (forms && forms.Item) {
            if (forms.Item instanceof Array) {
                _.forEach(forms.Item, function (d) {
                    var hasChildren = false;
                    if (d['@hasChildren']) {
                        if (d['@hasChildren'].toString().toLowerCase() === 'true') {
                            hasChildren = true;
                        }
                    }

                    // ITEMS that have children should show 2 Folders (Open Instances, Closed Instances)
                    // Expanding one of those should call /App/BrowseFormInstances
                    // Click the Folder Text should call /App/SearchFormInstances
                    var instanceFolders = [];
                    if (hasChildren & groupType !== constants.FORMS_VIEW_GROUP_TYPE) {
                        instanceFolders = [{
                            nodeName: 'Open Instances',
                            url: '',
                            icon: ICON_EMPTY,
                            id: d['@id'] + 'OPEN_INST',
                            groupType: groupType,
                            nodeType: 'browseFormInstances',
                            hasChildren: true,
                            parentId: d['@id'],
                            toggleIcon: 'pf-carot-left'
                        },
                            {
                                nodeName: 'Closed Instances',
                                url: '',
                                icon: ICON_EMPTY,
                                id: d['@id'] + 'CLOSED_INST',
                                groupType: groupType,
                                nodeType: 'browseFormInstances',
                                hasChildren: true,
                                parentId: d['@id'],
                                toggleIcon: 'pf-carot-left'
                            }]
                    }

                    nodes.push({
                        nodeName: d['@name'],
                        url: '#',
                        icon: ICON_EMPTY,
                        id: groupType === constants.FORMS_LIBRARY_GROUP_TYPE ? groupType + '_' + d['@libraryId'] : groupType + '_' + d['@id'],
                        groupType: groupType,
                        nodeType: itemNodeType,
                        hasChildren: hasChildren,
                        toggleIcon: hasChildren ? 'pf-carot-left' : '',
                        parentId: selectedId,
                        nodes: instanceFolders,
                        linkId: d['@linkId']
                    });
                });
            }

            // In the case that we have a single object instead of an array of items.
            else {
                var hasChildren = false;
                if (forms.Item['@hasChildren']) {
                    if (forms.Item['@hasChildren'].toString().toLowerCase() === 'true') {
                        hasChildren = true;
                    }
                }
                //// ITEMS that have children should show 2 Folders (Open Instances, Closed Instances)
                // Expanding one of those should call /App/BrowseFormInstances
                // Click the Folder Text should call /App/SearchFormInstances
                var instanceFolders = [];
                if (hasChildren & groupType !== constants.FORMS_VIEW_GROUP_TYPE) {
                    instanceFolders = [{
                        nodeName: 'Open Instances',
                        url: '',
                        icon: ICON_EMPTY,
                        id: forms.Item['@id'] + 'OPEN_INST',
                        groupType: groupType,
                        nodeType: 'browseFormInstances',
                        hasChildren: true,
                        parentId: selectedId,
                        toggleIcon: 'pf-carot-left'
                    },
                        {
                            nodeName: 'Closed Instances',
                            url: '',
                            icon: ICON_EMPTY,
                            id: forms.Item['@id'] + 'CLOSED_INST',
                            groupType: groupType,
                            nodeType: 'browseFormInstances',
                            hasChildren: true,
                            parentId: selectedId,
                            toggleIcon: 'pf-carot-left'
                        }]
                }

                nodes.push({
                    nodeName: forms.Item['@name'],
                    url: '#',
                    icon: ICON_EMPTY,
                    id: groupType === constants.FORMS_LIBRARY_GROUP_TYPE ? groupType + '_' + forms.Item['@libraryId'] : groupType + '_' + forms.Item['@id'],
                    groupType: groupType,
                    nodeType: itemNodeType,
                    hasChildren: hasChildren,
                    toggleIcon: hasChildren ? 'pf-carot-left' : '',
                    parentId: selectedId,
                    nodes: instanceFolders,
                    linkId: forms.Item['@linkId']
                });
            }
        }

        return nodes;
    }

    displayDefaultEditFormsDetailView() {
        this.processHandleSection( undefined, 'editForms' );
    }

    _onDeletingForm(formId, isFolder = false) {
        // Look for the li and remove it
        const $element = $(`a[data-itemid$='${formId}']`);
        const itemId = $element.attr('data-itemid');
        $element.parent().remove();

        let details = $(`#well${itemId}`);
        if (details) {
            details.remove();
        }

        this.displayDefaultEditFormsDetailView();

        if (!isFolder) {
            NotificationService.success(`Deleted App. Clicking undo restores it.`);
        }
        else{
            NotificationService.success(`Deleted folder. Clicking undo restores it.`);
        }
    }

    _onDeletingDraftInstances(formId) {
        // Click the Form Node
        var expElement = $('.group-items li a[data-itemid="1-' + formId + '"] ');

        if(expElement.length>0){
            var ev = {
                currentTarget: expElement[0]
            };
            this.handleSelectedGroupItem(ev);
        }

        $('#well' + formId + 'OPEN_INST ul').empty();
        $('#well' + formId + 'CLOSED_INST ul').empty();

    }

    shareForm(formId, groupType, itemId, groupId, name) {
        const $element = $(`a[data-itemid$='${formId}']`).parent();

        if ($element.length) {
            $element.remove();
        }

        this.reloadFormDetails(formId, groupType, itemId);

        let isAddedOnRoot = groupId === constants.DEFAULT_GROUP_ID;
        let dataTarget = isAddedOnRoot ? '#well_3 >' :`#well${groupId}`;
        this.addNode(isAddedOnRoot,dataTarget,groupType,{formId, name, groupType, itemId, groupId});
    }

    unShareForm(formId, groupType, itemId,groupId,name) {
        const $element = $(`a[data-itemid$='${formId}']`).parent();

        if ($element.length) {
            $element.remove();
        }

        let isAddedOnRoot = groupId === constants.DEFAULT_GROUP_ID;
        let dataTarget = isAddedOnRoot ? '#well_2 >' :`#well${groupId}`;
        this.addNode(isAddedOnRoot,dataTarget,groupType,{formId, name, groupType, itemId});
    }

    getFormInstances(formId, element) {
        $(element).parents(".dropdown").find('.btn').html($(element).text() + ' <span class="caret"></span>');
        $(element).parents(".dropdown").find('.btn').val($(element).data('value'));

        RestService.getFormDetails(formId).then((formDetailsResult) => {

            const formDetailsData = formDetailsResult.RESULT.RESPONSE.PrivateFormDetails;
            const openAttentionInstances = formDetailsData.OpenAttentionInstances;
            const openNoAttentionInstances = formDetailsData.OpenNoAttentionInstances;
            const closedInstances = formDetailsData.ClosedInstances;
            const archivedInstances = formDetailsData.ArchivedInstances;
            const totalOpenInstances = parseInt(openAttentionInstances) + parseInt(openNoAttentionInstances);
            const totalInstances = parseInt(totalOpenInstances) + parseInt(closedInstances) + parseInt(archivedInstances);


            let tree=$("ul.directory-tree");
            tree.find('.detailInstance').addClass('detFormInstance');
            tree.find('.totalInstances').html(totalInstances);
            tree.find('.viewTotalInstances').attr('data-itemid', formId).attr('attentionLevel','-1');

            tree.find('.totalOpenInstances').html(totalOpenInstances);
            tree.find('.viewTotalOpenInstances').attr('data-itemid',formId + 'OPEN_INST').attr('attentionLevel','-1');

            tree.find('.openAttentionInstances').html(openAttentionInstances);
            tree.find('.viewOpenAttentInstances').attr('data-itemid',formId ).attr('attentionLevel','1.5');


            tree.find('.openNoAttentionInstances').html(openNoAttentionInstances);
            tree.find('.viewOpenNoAttentInstances').attr('data-itemid',formId).attr('attentionLevel','0');

            tree.find('.closedInstances').html(closedInstances);
            tree.find('.viewClosedInstances').attr('data-itemid',formId + 'CLOSED_INST').attr('attentionLevel','-1');


            tree.find('.archivedInstances').html(archivedInstances);
            tree.find('.viewArchivedInstances').attr('data-itemid',formId);

        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });

    }

    getAllFormInstances(ev){
        $(ev.currentTarget).parents(".dropdown").find('.btn').html($(ev.currentTarget).text() + ' <span class="caret"></span>');
        $(ev.currentTarget).parents(".dropdown").find('.btn').val($(ev.currentTarget).data('value'));
        RestService.getAllInstances().then((response)=> {

            const formDetailsData = response.manageDashboard;
            const openAttentionInstances = formDetailsData.openAttention;
            const openNoAttentionInstances = formDetailsData.openNoAttention;
            const closedInstances = formDetailsData.closed;
            const archivedInstances = formDetailsData.archived;
            const totalOpenInstances = parseInt(openAttentionInstances) + parseInt(openNoAttentionInstances);
            const totalInstances = parseInt(totalOpenInstances) + parseInt(closedInstances) + parseInt(archivedInstances);


            let tree=$("ul.directory-tree");
            tree.find('.detailInstance').removeClass('detFormInstance');
            tree.find('.totalInstances').html(totalInstances);
            tree.find('.viewTotalInstances').removeAttr('data-itemid').removeAttr('attentionLevel','-1');

            tree.find('.totalOpenInstances').html(totalOpenInstances);
            tree.find('.viewTotalOpenInstances').removeAttr('data-itemid').removeAttr('attentionLevel');

            tree.find('.openAttentionInstances').html(openAttentionInstances);
            tree.find('.viewOpenAttentInstances').removeAttr('data-itemid').removeAttr('attentionLevel');


            tree.find('.openNoAttentionInstances').html(openNoAttentionInstances);
            tree.find('.viewOpenNoAttentInstances').removeAttr('data-itemid').removeAttr('attentionLevel');

            tree.find('.closedInstances').html(closedInstances);
            tree.find('.viewClosedInstances').removeAttr('data-itemid').removeAttr('attentionLevel');


            tree.find('.archivedInstances').html(archivedInstances);
            tree.find('.viewArchivedInstances').removeAttr('data-itemid');



        }).catch((err=>{
            console.log('Error retrieving new archive details view',err);
            NotificationService.error('Error retrieving new archive details view '+err.MESSAGE);
        }));
    }

    loadViewByInstance(ev) {
        this.killDetailView();
        if($(ev.currentTarget).hasClass('viewArchivedInstances')){
            RestService.getFormList(constants.OWNER_ARCHIVED_PERMISSION).then((formListData)=> {
                let newArchiveModel=new NewArchiveModel();
                let breadcrumbs = [
                    {name: 'App', route: '#forms', id: "goToForms"},
                    {name: 'Edit App', route: '#forms', id: "goToEditForms"}
                ];
                newArchiveModel.set('breadcrumbs', breadcrumbs);
                let forms=[];
                if(formListData.formsXML.forms) {
                    forms = formListData.formsXML.forms.form instanceof Array
                        ? formListData.formsXML.forms.form
                        : [formListData.formsXML.forms.form];
                }
                else{
                    formListData.formsXML.forms={form:[]};
                    forms=formListData.formsXML.forms.form;
                }
                newArchiveModel.set('formList',forms);
                newArchiveModel.set('isArchived',true);
                newArchiveModel.set('filterOptions',{
                    status:'-1',
                    name:'',
                    dateOfFilter:'before',
                    dateOfType:'first',
                    firstSubmissionFrom:constants.DEFAULT_GROUP_ID,
                    firstSubmissionTo:constants.DEFAULT_GROUP_ID,
                    lastSubmissionFrom:constants.DEFAULT_GROUP_ID,
                    lastSubmissionTo:constants.DEFAULT_GROUP_ID
                });
                newArchiveModel.set('filterFormList',[]);

                let newDetailView=  new NewArchiveDetailsView({
                    model: newArchiveModel,
                    el: constants.DASHBOARD_MAIN_PANEL
                });

                listService.dashboardLayout.mainPanelView=newDetailView;
                this.detailView = newDetailView;
                this.detailView.render();
            }).catch((err=>{
                console.log('Error retrieving new archive details view',err);
                NotificationService.error('Error retrieving new archive details view '+err.MESSAGE);
            }));
        }else{
            let itemId = ev.currentTarget.attributes['data-itemid'].value;
            const attentionLevel = ev.currentTarget.attributes['attentionLevel'].value;

            let isClosed = (new RegExp('CLOSED').test(itemId) || ev.currentTarget.innerText === 'Closed') ? true : false;
            let title = isClosed ? 'Closed' : 'Open';

            let formId = itemId.replace('OPEN_INST', '').replace('CLOSED_INST', '');
            let formName = $(ev.currentTarget).text();
            let formDetailsModel = new FormDetailsModel();

            // Configure Title and Breadcrumbs
            let breadcrumbs = [
                {name: 'Apps', route: '#forms', id: "goToForms"},
                {name: 'Edit App', route: '#forms', id: "goToEditForms"},
                {name: formName, route: ''}
            ];

            isClosed= isClosed ? "1" : "0";
            isClosed=$(ev.currentTarget).hasClass('viewTotalInstances') ? '-1': isClosed;
            formDetailsModel.set({
                'dashboardTitle': title + ' Instances - ' + formName,
                'breadcrumbs': breadcrumbs,
                'formId': formId,
                status:  isClosed ,
                attentionLevel:attentionLevel
            });

            let newFormInstancesView = new FormInstancesView({
                model: formDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL,
                closed: isClosed
            });
            listService.dashboardLayout.mainPanelView=newFormInstancesView;
            this.detailView = newFormInstancesView;
            this.detailView.render();
        }

    }

    reloadFormDetails(formId, groupType, itemId) {
        this.reloadFormDetailsDebounced(formId, groupType, itemId);
    }

    renderAndBindFormDetailView(formDetailsResult,formId,groupType,itemId){
        this.killDetailView();
        //eventBus.off(constants.EV_UPDATE_FORM_DETAILS);
        const formDetailsData = formDetailsResult.RESULT.RESPONSE.PrivateFormDetails;
        let permissionList = [];
        let dependenceList = [];

        // Adding Permissions to an array if any
        if (formDetailsData['PermissionsXML']) {
            permissionList = formDetailsData['PermissionsXML'].Permissions.User instanceof Array
                ? formDetailsData['PermissionsXML'].Permissions.User
                : [formDetailsData['PermissionsXML'].Permissions.User];
        }
        //Adding Dependencies to an array if any
        if (formDetailsData['Dependencies']) {
            let tmpDependenceList = formDetailsData['Dependencies'].Dependency instanceof Array
            ? formDetailsData['Dependencies'].Dependency
            : [formDetailsData['Dependencies'].Dependency];
            dependenceList = _.sortBy(tmpDependenceList,['@type', '@name']);
        }
        // Filling the model with data coming from API.
        let formDetailsModel = new FormDetailsModel();
        // PF-2307
        formDetailsModel.set('ownerId', formDetailsData.OwnerId);
        formDetailsModel.set('ownerName', formDetailsData.OwnerName);

        formDetailsModel.set('formName', formDetailsData.Name);
        formDetailsModel.set('currentFormName', formDetailsData.Name);
        formDetailsModel.set('dateCreated', util.getFormattedDate(formDetailsData.CreatedDate));
        formDetailsModel.set('lastUpdate', util.getFormattedDate(formDetailsData.LastUpdate));
        formDetailsModel.set('lastUpdateUTC', util.formatUTC(formDetailsData.LastUpdate));
        formDetailsModel.set('latestVersion', formDetailsData.Version);
        formDetailsModel.set('viewedBy', permissionList);
        formDetailsModel.set('publishedVersion', formDetailsData.DeployVersion);
        formDetailsModel.set('isActive', formDetailsData.IsActive === 'True' ? true : false);
        formDetailsModel.set('currentIsActive', formDetailsData.IsActive === 'True' ? true : false);
        formDetailsModel.set('mobileFormIsActive', formDetailsData.MobileEnabled === 'True' ? true : false);
        formDetailsModel.set('mobileWizardIsCompleted', formDetailsData.IsWizardCompleted === 'True' ? true : false);
        formDetailsModel.set('mobileDesignExists', formDetailsData.IsWizardCompleted);
        formDetailsModel.set('requireLoginFromEmail', formDetailsData.NotificationRequiresLogin === 'True' ? true : false);
        formDetailsModel.set('currentRequireLoginFromEmail', formDetailsData.NotificationRequiresLogin === 'True' ? true : false);
        formDetailsModel.set('version', 'latest');
        formDetailsModel.set('formId', formId);
        formDetailsModel.set('versionList', formDetailsData.VersionList.Version);
        formDetailsModel.set('ownerName', formDetailsData.OwnerName);
        formDetailsModel.set('LastRecoveryUpdateDate', formDetailsData.LastRecoveryUpdateDate);
        
        formDetailsModel.set('permissionList', _.cloneDeep(permissionList));
        formDetailsModel.set('userPermissionList', formDetailsData.UserPermissionsXML.Permissions);
        formDetailsModel.set('currentPermissionList', _.cloneDeep(permissionList));

        formDetailsModel.set('hasChanges', false);
        formDetailsModel.set('responsive', formDetailsData.IsResponsive);
        formDetailsModel.set('containsMobileErrors', formDetailsData.ContainsMobileErrors);
        formDetailsModel.set('dependenceList', Object.assign([],dependenceList));

        // Getting formInstances values from the API so they can be rendered on the tree
        const openAttentionInstances = formDetailsData.OpenAttentionInstances;
        const openNoAttentionInstances = formDetailsData.OpenNoAttentionInstances;
        const closedInstances = formDetailsData.ClosedInstances;
        const archivedInstances = formDetailsData.ArchivedInstances;
        const totalOpenInstances = parseInt(openAttentionInstances) + parseInt(openNoAttentionInstances);
        const totalInstances = parseInt(totalOpenInstances) + parseInt(closedInstances) + parseInt(archivedInstances);

        formDetailsModel.set('openAttentionInstances', openAttentionInstances);
        formDetailsModel.set('openNoAttentionInstances', openNoAttentionInstances);
        formDetailsModel.set('closedInstances', closedInstances);
        formDetailsModel.set('archivedInstances', archivedInstances);
        formDetailsModel.set('totalOpenInstances', totalOpenInstances);
        formDetailsModel.set('totalInstances', totalInstances);

        formDetailsModel.set('LinkId', formDetailsData.LinkId);
        formDetailsModel.set('Width', formDetailsData.Width);
        formDetailsModel.set('Height', formDetailsData.Height);
        formDetailsModel.set('IsDeployed', formDetailsData.IsDeployed);
        formDetailsModel.set('GroupId', formDetailsData.GroupId || itemId);
        formDetailsModel.set('IsPrivate', formDetailsData.IsPrivate);
        formDetailsModel.set('groupType', groupType);
        if(formDetailsData.ApiReference){
            formDetailsModel.set('apiReference',formDetailsData.ApiReference);
        }

        formDetailsModel.set('reflowEnabled', util.isTrue(formDetailsData.ReflowEnabled));

        // Configure Title and Breadcrumbs
        var breadcrumbs = [
            {name: 'Home', route: '#forms'},
            {name: 'Apps', route: '#forms'}
        ];

        formDetailsModel.set('dashboardTitle', groupType !== constants.FORMS_SHARED_GROUP_TYPE
        ? `App - ${formDetailsData.Name}` : `Shared App - ${formDetailsData.Name}`);
        formDetailsModel.set('breadcrumbs', breadcrumbs);

        // **************************
        let selectedForm = {
                formId: formDetailsModel.get('formId'),
                formName: formDetailsModel.get('formName'),
                groupId: formDetailsModel.get('GroupId'),
                groupType:formDetailsModel.get('groupType'),
                formLink:formDetailsModel.get('LinkId'),
                versionList:formDetailsModel.get('versionList'),
                totalOpenInstances:formDetailsModel.get('totalOpenInstances')
        };

        listService.dashboardFormsItems
            .setDefaultValue()
            .setPropValue('formItemSelected', selectedForm);

        const refreshButton = $('#pf-refresh-main-view'); //reset id in refresh button
        refreshButton.attr("data-appid", selectedForm.formId);    

        let newFormDetails = new FormDetailsView({model: formDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
        listService.dashboardLayout.mainPanelView = newFormDetails;
        this.detailView = newFormDetails;
        this.detailView.render();
    }

    loadViewableFormInstanceDetails(formId, formName, linkId) {

        this.linkId = this.linkId || linkId;

        RestService.searchViewableFormInstanceDetails(formId).then((data)=> {
            this.bindDataToInstanceSearchDetailView(formId, formName, data)
        });
    }

    bindDataToInstanceSearchDetailView(formId,formName,data){

        let viewableInstanceModel = new ViewableInstanceModel();
        const viewableDetails = data.RESULT.RESPONSE;


        viewableInstanceModel.set('owner', viewableDetails.OwnerName, {silent: true});
        viewableInstanceModel.set('ownerId', viewableDetails.OwnerId, {silent: true});
        viewableInstanceModel.set('lastUpdate', viewableDetails.DeployDate, {silent: true});
        viewableInstanceModel.set('lastVersion', viewableDetails.DeployVersion, {silent: true});
        viewableInstanceModel.set('formId', formId, {silent: true});
        viewableInstanceModel.set('LinkId', viewableDetails.LinkId || this.linkId, {silent: true});
        viewableInstanceModel.set('formVersionId', viewableDetails.FormVersionId, {silent:true});

        var instances = null;
        if (viewableDetails.InstanceList) {
            instances = viewableDetails.InstanceList.Instance instanceof Array
                ? viewableDetails.InstanceList.Instance
                : [viewableDetails.InstanceList.Instance];
        }
        viewableInstanceModel.set('gridData', instances, {silent: true});
        viewableInstanceModel.set('formName', formName, {silent: true});
        // Configure Title and Breadcrumbs
        var breadcrumbs = [
            {name: 'Home', route: '#forms'},
            {name: 'Apps', route: '#forms'},
            {name: formName, route: ''}
        ];

        viewableInstanceModel.set('dashboardTitle', 'App - ' + formName);
        viewableInstanceModel.set('breadcrumbs', breadcrumbs);
        // **************************
        this.killDetailView();

        let newViewableInstance= new ViewableInstanceView({
            model: viewableInstanceModel,
            el: constants.DASHBOARD_MAIN_PANEL
        });

        listService.dashboardFormsItems
            .setDefaultValue();

        listService.dashboardLayout.mainPanelView = newViewableInstance;

        this.detailView = newViewableInstance;
        this.detailView.render();
    }

    // PF-2422: display undeleted form in dashboard tree and form details

    openUndeletedFormDetails(formId, formName, groupType, itemId,selectedGroupType,selectedNodeOnTree,selectedNodeTarget ) {
        // console.log(`formId ${formId}, formName ${formName}, groupType ${groupType}, itemId ${groupType}`);

        const injectedResponse = {
            formId: formId,
            name: formName, // Name inserted into tree
            groupType: groupType || constants.FORMS_PRIVATE_GROUP_TYPE,
            itemId: itemId,
            msg: `App "${formName}" restored`
        };



        // Insert form name into tree, expand it, and display the form's details.
        if (constants.FORMS_SHARED_GROUP_TYPE === groupType) {
            this.expandUpdatedListOfSharedNodes(false, injectedResponse, this.selectedGroupType, this.selectedNodeOnTree, this.selectedNodeTarget );
        } else {
            this.expandUpdatedListOfPrivateNodes(false, injectedResponse, selectedGroupType,
                selectedNodeOnTree, selectedNodeTarget);
        }
    }
    
    refreshFormsMainView(){
        const requestParamsObject = {
            includeRecentManagedForms: 'true',
            includeAllManagedForms: 'true',
            includeFavoriteForms: 'true'
        };

        RestService.getDashboardDetails(requestParamsObject).then((data)=> {
            let currentFavoritesList = [];
            let recentForms = [];
            let formInstances = [];
            let result = data.RESULT.RESPONSE;

            if (result.allManagedForms && result.allManagedForms.form) {
                formInstances = result.allManagedForms.form instanceof Array
                    ? result.allManagedForms.form
                    : [result.allManagedForms.form];
            }

            if (result.recentManagedForms && result.recentManagedForms.form) {
                recentForms = result.recentManagedForms.form instanceof Array
                    ? result.recentManagedForms.form
                    : [result.recentManagedForms.form];
            }

            if (result.favoriteForms && result.favoriteForms.form) {
                currentFavoritesList = result.favoriteForms.form instanceof Array
                    ? result.favoriteForms.form
                    : [result.favoriteForms.form];
            }

            let formDetailsModel = new FormDetailsModel();
            formDetailsModel.set('recentForms', recentForms);
            formDetailsModel.set('formInstances', formInstances);
            formDetailsModel.set('currentFavoritesList', currentFavoritesList);
            
            let formMainViewDetails = new AppWorkspaceView({model: formDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});
            listService.dashboardLayout.mainPanelView = formMainViewDetails;
            this.detailView = formMainViewDetails;
            this.detailView.render();

        }).catch((error) => {
            console.log(error);
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    processDeleteform(elm) {
        const formIdData = elm.itemid.split('_'),
            formId = formIdData.length === 1 ? elm.itemid : formIdData[1];
        RestService.getFormDetails(formId).then((formDetails) => {
            const loggedUser = RestService.getProfile(),
                formData = formDetails.RESULT.RESPONSE.PrivateFormDetails;

            if (loggedUser.UserId !== formData.OwnerId) {
                this._launchModal({
                    title: constants.MODAL_DELETE_FORM_TITLE,
                    message: constants.MODAL_DELETE_NOT_ALLOWED_LABEL,
                    modalHeight: 130,
                    modalWidth: 350,
                    elm: elm
                });
                return;
            }
            let element;
            if(formData.HasInstances === 'True'){
                element=$(`a[data-linkid=${formData.LinkId}]`).parent().first().prop('outerHTML');
                element+=$(`a[data-linkid=${formData.LinkId}]`).parent().first().next().prop('outerHTML')
            }

            const modalParams = {
                formName: formData.Name,
                formId: formId,
                formLink: formData.LinkId,
                versionList: formData.VersionList.Version,
                totalOpenInstances: formData.totalOpenInstances,
                groupId: elm.parentid,
                groupType:elm.grouptype,
                elementToAttach:element

            };

            const deleteModal = new DeleteModal({
                model: new Model(modalParams),
                width: 470, height: 270
            });
            deleteModal.render().then( result => { }, err => console.log(`deleteForm rejection:`, err)).catch(err => console.log(err));

        }).catch((error) => {
            NotificationService.error(error || 'Unknown Error');
        });
    }

    apiGetFormsByGroupType({groupTypeId, groupId, dataTarget, nodeType, triggerClick}) {

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        RestService.getFormsByGroupType(groupTypeId, groupId).then((data) => {
            util.enableReloadLink();
            let section = groupTypeId === constants.PERSONAL_FOLDER_GROUP_TYPE  || groupTypeId === constants.ACCOUNT_FOLDER_GROUP_TYPE ? 'View Apps': 'Edit Apps';
            this.selectedNodeOnTree = this.renderFormBrowseNodes(groupTypeId,groupId,dataTarget,data,section);
            this.selectedNodeTarget = dataTarget;
            this.selectedGroupType = groupTypeId;
            this.selectedNodeType = nodeType;

                _.forEach(data.Item, function (d) {
                    var hasChildren = false;
                    if (d['@hasChildren']) {
                        if (d['@hasChildren'].toString().toLowerCase() === 'true') {
                            hasChildren = true;
                        }
                    }

                    // ITEMS that have children should show 2 Folders (Open Instances, Closed Instances)
                    // Expanding one of those should call /App/BrowseFormInstances
                    // Click the Folder Text should call /App/SearchFormInstances
                    var instanceFolders = [];
                    if (hasChildren & groupType !== constants.FORMS_VIEW_GROUP_TYPE) {
                        instanceFolders = [{
                            nodeName: 'Open Instances',
                            url: '',
                            icon: ICON_EMPTY,
                            id: d['@id'] + 'OPEN_INST',
                            groupType: groupType,
                            nodeType: 'browseFormInstances',
                            hasChildren: true,
                            parentId: d['@id'],
                            toggleIcon: 'pf-carot-left'
                        },
                            {
                                nodeName: 'Closed Instances',
                                url: '',
                                icon: ICON_EMPTY,
                                id: d['@id'] + 'CLOSED_INST',
                                groupType: groupType,
                                nodeType: 'browseFormInstances',
                                hasChildren: true,
                                parentId: d['@id'],
                                toggleIcon: 'pf-carot-left'
                            }]
                    }

                    nodes.push({
                        nodeName: d['@name'],
                        url: '#',
                        icon: ICON_EMPTY,
                        id: groupType === constants.FORMS_LIBRARY_GROUP_TYPE ? groupType + '_' + d['@libraryId'] : groupType + '_' + d['@id'],
                        groupType: groupType,
                        nodeType: itemNodeType,
                        hasChildren: hasChildren,
                        toggleIcon: hasChildren ? 'pf-carot-left' : '',
                        parentId: selectedId,
                        nodes: instanceFolders
                    });
                });

            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((error) => {
            console.log(error);
            util.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    render() {
        super.render();
    }
}

export default FormLeftPanelView;
